System.register(["./dyn-feature-products.js", "./dyn-is-svg-element.js"], function(exports, module) {
  "use strict";
  var isMobile, noop, invariant, frameData, MotionGlobalConfig, cancelFrame, frame, velocityPerSecond, clamp, defaultOffset, interpolate, pipe, mix, number, px, memo, statsBuffer, supportsScrollTimeline, complex, isCSSVariableToken, percent, degrees, vw, vh, floatRegex, progressPercentage, alpha, scale, color, analyseComplexValue, createRenderBatcher, isSVGElement, resolveElements, mixNumber, fillOffset, progress, isCSSVariableName;
  return {
    setters: [(module2) => {
      isMobile = module2.i;
    }, (module2) => {
      noop = module2.n;
      invariant = module2.U;
      frameData = module2.b;
      MotionGlobalConfig = module2.W;
      cancelFrame = module2.a;
      frame = module2.f;
      velocityPerSecond = module2._;
      clamp = module2.c;
      defaultOffset = module2.h;
      interpolate = module2.i;
      pipe = module2.Y;
      mix = module2.o;
      number = module2.M;
      px = module2.p;
      memo = module2.m;
      statsBuffer = module2.s;
      supportsScrollTimeline = module2.C;
      complex = module2.K;
      isCSSVariableToken = module2.g;
      percent = module2.P;
      degrees = module2.O;
      vw = module2.S;
      vh = module2.R;
      floatRegex = module2.$;
      progressPercentage = module2.Q;
      alpha = module2.L;
      scale = module2.N;
      color = module2.D;
      analyseComplexValue = module2.J;
      createRenderBatcher = module2.k;
      isSVGElement = module2.l;
      resolveElements = module2.r;
      mixNumber = module2.z;
      fillOffset = module2.j;
      progress = module2.Z;
      isCSSVariableName = module2.e;
    }],
    execute: function() {
      exports({
        B: getVariableValue,
        C: parseCSSVariable,
        D: makeAnimationInstant,
        E: inertia,
        F: defaultEasing,
        H: keyframes,
        I: spring,
        K: calcGeneratorDuration,
        O: createGeneratorEasing,
        P: isGenerator,
        S: flushKeyframeResolvers,
        T: convertOffsetToTimes,
        V: startWaapiAnimation,
        W: supportsBrowserAnimation,
        Z: defaultTransformValue,
        _: parseValueFromTransform,
        a0: setStyle,
        a2: isSVGSVGElement,
        aa: getAnimatableNone,
        ac: addUniqueItem,
        ad: moveItem,
        aq: cubicBezier,
        aw: getEasingForSegment,
        k: getValueTransition$1,
        m: motionValue,
        o: applyGeneratorOptions,
        p: mapEasingToNativeEasing,
        r: removeItem,
        u: fillWildcards,
        x: createScopedAnimate,
        y: animateValue
      });
      function addUniqueItem(arr, item) {
        if (arr.indexOf(item) === -1)
          arr.push(item);
      }
      function removeItem(arr, item) {
        const index = arr.indexOf(item);
        if (index > -1)
          arr.splice(index, 1);
      }
      function moveItem([...arr], fromIndex, toIndex) {
        const startIndex = fromIndex < 0 ? arr.length + fromIndex : fromIndex;
        if (startIndex >= 0 && startIndex < arr.length) {
          const endIndex = toIndex < 0 ? arr.length + toIndex : toIndex;
          const [item] = arr.splice(fromIndex, 1);
          arr.splice(endIndex, 0, item);
        }
        return arr;
      }
      const isNumericalString = exports("ae", (v) => /^-?(?:\d+(?:\.\d+)?|\.\d+)$/u.test(v));
      const isZeroValueString = exports("af", (v) => /^0[^.\s]+$/u.test(v));
      class SubscriptionManager {
        constructor() {
          this.subscriptions = [];
        }
        add(handler) {
          addUniqueItem(this.subscriptions, handler);
          return () => removeItem(this.subscriptions, handler);
        }
        notify(a, b, c) {
          const numSubscriptions = this.subscriptions.length;
          if (!numSubscriptions)
            return;
          if (numSubscriptions === 1) {
            this.subscriptions[0](a, b, c);
          } else {
            for (let i = 0; i < numSubscriptions; i++) {
              const handler = this.subscriptions[i];
              handler && handler(a, b, c);
            }
          }
        }
        getSize() {
          return this.subscriptions.length;
        }
        clear() {
          this.subscriptions.length = 0;
        }
      }
      exports("ag", SubscriptionManager);
      const secondsToMilliseconds = exports("l", (seconds) => seconds * 1e3);
      const millisecondsToSeconds = exports("ah", (milliseconds) => milliseconds / 1e3);
      const wrap = exports("ai", (min, max, v) => {
        const rangeSize = max - min;
        return ((v - min) % rangeSize + rangeSize) % rangeSize + min;
      });
      const calcBezier = (t, a1, a2) => (((1 - 3 * a2 + 3 * a1) * t + (3 * a2 - 6 * a1)) * t + 3 * a1) * t;
      const subdivisionPrecision = 1e-7;
      const subdivisionMaxIterations = 12;
      function binarySubdivide(x, lowerBound, upperBound, mX1, mX2) {
        let currentX;
        let currentT;
        let i = 0;
        do {
          currentT = lowerBound + (upperBound - lowerBound) / 2;
          currentX = calcBezier(currentT, mX1, mX2) - x;
          if (currentX > 0) {
            upperBound = currentT;
          } else {
            lowerBound = currentT;
          }
        } while (Math.abs(currentX) > subdivisionPrecision && ++i < subdivisionMaxIterations);
        return currentT;
      }
      function cubicBezier(mX1, mY1, mX2, mY2) {
        if (mX1 === mY1 && mX2 === mY2)
          return noop;
        const getTForX = (aX) => binarySubdivide(aX, 0, 1, mX1, mX2);
        return (t) => t === 0 || t === 1 ? t : calcBezier(getTForX(t), mY1, mY2);
      }
      const mirrorEasing = exports("au", (easing) => (p) => p <= 0.5 ? easing(2 * p) / 2 : (2 - easing(2 * (1 - p))) / 2);
      const reverseEasing = exports("av", (easing) => (p) => 1 - easing(1 - p));
      const backOut = exports("am", /* @__PURE__ */ cubicBezier(0.33, 1.53, 0.69, 0.99));
      const backIn = exports("ak", /* @__PURE__ */ reverseEasing(backOut));
      const backInOut = exports("al", /* @__PURE__ */ mirrorEasing(backIn));
      const anticipate = exports("aj", (p) => (p *= 2) < 1 ? 0.5 * backIn(p) : 0.5 * (2 - Math.pow(2, -10 * (p - 1))));
      const circIn = exports("an", (p) => 1 - Math.sin(Math.acos(p)));
      const circOut = exports("ap", reverseEasing(circIn));
      const circInOut = exports("ao", mirrorEasing(circIn));
      const easeIn = exports("ar", /* @__PURE__ */ cubicBezier(0.42, 0, 1, 1));
      const easeOut = exports("at", /* @__PURE__ */ cubicBezier(0, 0, 0.58, 1));
      const easeInOut = exports("as", /* @__PURE__ */ cubicBezier(0.42, 0, 0.58, 1));
      const isEasingArray = exports("ax", (ease2) => {
        return Array.isArray(ease2) && typeof ease2[0] !== "number";
      });
      function getEasingForSegment(easing, i) {
        return isEasingArray(easing) ? easing[wrap(0, easing.length, i)] : easing;
      }
      const isBezierDefinition = exports("i", (easing) => Array.isArray(easing) && typeof easing[0] === "number");
      const easingLookup = {
        linear: noop,
        easeIn,
        easeInOut,
        easeOut,
        circIn,
        circInOut,
        circOut,
        backIn,
        backInOut,
        backOut,
        anticipate
      };
      const isValidEasing = (easing) => {
        return typeof easing === "string";
      };
      const easingDefinitionToFunction = exports("f", (definition) => {
        if (isBezierDefinition(definition)) {
          invariant(definition.length === 4);
          const [x1, y1, x2, y2] = definition;
          return cubicBezier(x1, y1, x2, y2);
        } else if (isValidEasing(definition)) {
          return easingLookup[definition];
        }
        return definition;
      });
      let now;
      function clearTime() {
        now = void 0;
      }
      const time = exports("w", {
        now: () => {
          if (now === void 0) {
            time.set(frameData.isProcessing || MotionGlobalConfig.useManualTiming ? frameData.timestamp : performance.now());
          }
          return now;
        },
        set: (newTime) => {
          now = newTime;
          queueMicrotask(clearTime);
        }
      });
      const activeAnimations = exports("e", {
        layout: 0,
        mainThread: 0,
        waapi: 0
      });
      const frameloopDriver = (update) => {
        const passTimestamp = ({ timestamp }) => update(timestamp);
        return {
          start: (keepAlive = true) => frame.update(passTimestamp, keepAlive),
          stop: () => cancelFrame(passTimestamp),
          /**
           * If we're processing this frame we can use the
           * framelocked timestamp to keep things in sync.
           */
          now: () => frameData.isProcessing ? frameData.timestamp : time.now()
        };
      };
      const generateLinearEasing = exports("X", (easing, duration, resolution = 10) => {
        let points = "";
        const numPoints = Math.max(Math.round(duration / resolution), 2);
        for (let i = 0; i < numPoints; i++) {
          points += Math.round(easing(i / (numPoints - 1)) * 1e4) / 1e4 + ", ";
        }
        return `linear(${points.substring(0, points.length - 2)})`;
      });
      const maxGeneratorDuration = exports("L", 2e4);
      function calcGeneratorDuration(generator) {
        let duration = 0;
        const timeStep = 50;
        let state = generator.next(duration);
        while (!state.done && duration < maxGeneratorDuration) {
          duration += timeStep;
          state = generator.next(duration);
        }
        return duration >= maxGeneratorDuration ? Infinity : duration;
      }
      function createGeneratorEasing(options, scale2 = 100, createGenerator) {
        const generator = createGenerator({ ...options, keyframes: [0, scale2] });
        const duration = Math.min(calcGeneratorDuration(generator), maxGeneratorDuration);
        return {
          type: "keyframes",
          ease: (progress2) => {
            return generator.next(duration * progress2).value / scale2;
          },
          duration: millisecondsToSeconds(duration)
        };
      }
      const velocitySampleDuration = 5;
      function calcGeneratorVelocity(resolveValue, t, current) {
        const prevT = Math.max(t - velocitySampleDuration, 0);
        return velocityPerSecond(current - resolveValue(prevT), t - prevT);
      }
      const springDefaults = {
        // Default spring physics
        stiffness: 100,
        damping: 10,
        mass: 1,
        velocity: 0,
        // Default duration/bounce-based options
        duration: 800,
        // in ms
        bounce: 0.3,
        visualDuration: 0.3,
        // in seconds
        // Rest thresholds
        restSpeed: {
          granular: 0.01,
          default: 2
        },
        restDelta: {
          granular: 5e-3,
          default: 0.5
        },
        // Limits
        minDuration: 0.01,
        // in seconds
        maxDuration: 10,
        // in seconds
        minDamping: 0.05,
        maxDamping: 1
      };
      const safeMin = 1e-3;
      function findSpring({ duration = springDefaults.duration, bounce = springDefaults.bounce, velocity = springDefaults.velocity, mass = springDefaults.mass }) {
        let envelope;
        let derivative;
        let dampingRatio = 1 - bounce;
        dampingRatio = clamp(springDefaults.minDamping, springDefaults.maxDamping, dampingRatio);
        duration = clamp(springDefaults.minDuration, springDefaults.maxDuration, millisecondsToSeconds(duration));
        if (dampingRatio < 1) {
          envelope = (undampedFreq2) => {
            const exponentialDecay = undampedFreq2 * dampingRatio;
            const delta = exponentialDecay * duration;
            const a = exponentialDecay - velocity;
            const b = calcAngularFreq(undampedFreq2, dampingRatio);
            const c = Math.exp(-delta);
            return safeMin - a / b * c;
          };
          derivative = (undampedFreq2) => {
            const exponentialDecay = undampedFreq2 * dampingRatio;
            const delta = exponentialDecay * duration;
            const d = delta * velocity + velocity;
            const e = Math.pow(dampingRatio, 2) * Math.pow(undampedFreq2, 2) * duration;
            const f = Math.exp(-delta);
            const g = calcAngularFreq(Math.pow(undampedFreq2, 2), dampingRatio);
            const factor = -envelope(undampedFreq2) + safeMin > 0 ? -1 : 1;
            return factor * ((d - e) * f) / g;
          };
        } else {
          envelope = (undampedFreq2) => {
            const a = Math.exp(-undampedFreq2 * duration);
            const b = (undampedFreq2 - velocity) * duration + 1;
            return -1e-3 + a * b;
          };
          derivative = (undampedFreq2) => {
            const a = Math.exp(-undampedFreq2 * duration);
            const b = (velocity - undampedFreq2) * (duration * duration);
            return a * b;
          };
        }
        const initialGuess = 5 / duration;
        const undampedFreq = approximateRoot(envelope, derivative, initialGuess);
        duration = secondsToMilliseconds(duration);
        if (isNaN(undampedFreq)) {
          return {
            stiffness: springDefaults.stiffness,
            damping: springDefaults.damping,
            duration
          };
        } else {
          const stiffness = Math.pow(undampedFreq, 2) * mass;
          return {
            stiffness,
            damping: dampingRatio * 2 * Math.sqrt(mass * stiffness),
            duration
          };
        }
      }
      const rootIterations = 12;
      function approximateRoot(envelope, derivative, initialGuess) {
        let result = initialGuess;
        for (let i = 1; i < rootIterations; i++) {
          result = result - envelope(result) / derivative(result);
        }
        return result;
      }
      function calcAngularFreq(undampedFreq, dampingRatio) {
        return undampedFreq * Math.sqrt(1 - dampingRatio * dampingRatio);
      }
      const durationKeys = ["duration", "bounce"];
      const physicsKeys = ["stiffness", "damping", "mass"];
      function isSpringType(options, keys) {
        return keys.some((key) => options[key] !== void 0);
      }
      function getSpringOptions(options) {
        let springOptions = {
          velocity: springDefaults.velocity,
          stiffness: springDefaults.stiffness,
          damping: springDefaults.damping,
          mass: springDefaults.mass,
          isResolvedFromDuration: false,
          ...options
        };
        if (!isSpringType(options, physicsKeys) && isSpringType(options, durationKeys)) {
          if (options.visualDuration) {
            const visualDuration = options.visualDuration;
            const root = 2 * Math.PI / (visualDuration * 1.2);
            const stiffness = root * root;
            const damping = 2 * clamp(0.05, 1, 1 - (options.bounce || 0)) * Math.sqrt(stiffness);
            springOptions = {
              ...springOptions,
              mass: springDefaults.mass,
              stiffness,
              damping
            };
          } else {
            const derived = findSpring(options);
            springOptions = {
              ...springOptions,
              ...derived,
              mass: springDefaults.mass
            };
            springOptions.isResolvedFromDuration = true;
          }
        }
        return springOptions;
      }
      function spring(optionsOrVisualDuration = springDefaults.visualDuration, bounce = springDefaults.bounce) {
        const options = typeof optionsOrVisualDuration !== "object" ? {
          visualDuration: optionsOrVisualDuration,
          keyframes: [0, 1],
          bounce
        } : optionsOrVisualDuration;
        let { restSpeed, restDelta } = options;
        const origin = options.keyframes[0];
        const target = options.keyframes[options.keyframes.length - 1];
        const state = { done: false, value: origin };
        const { stiffness, damping, mass, duration, velocity, isResolvedFromDuration } = getSpringOptions({
          ...options,
          velocity: -millisecondsToSeconds(options.velocity || 0)
        });
        const initialVelocity = velocity || 0;
        const dampingRatio = damping / (2 * Math.sqrt(stiffness * mass));
        const initialDelta = target - origin;
        const undampedAngularFreq = millisecondsToSeconds(Math.sqrt(stiffness / mass));
        const isGranularScale = Math.abs(initialDelta) < 5;
        restSpeed || (restSpeed = isGranularScale ? springDefaults.restSpeed.granular : springDefaults.restSpeed.default);
        restDelta || (restDelta = isGranularScale ? springDefaults.restDelta.granular : springDefaults.restDelta.default);
        let resolveSpring;
        if (dampingRatio < 1) {
          const angularFreq = calcAngularFreq(undampedAngularFreq, dampingRatio);
          resolveSpring = (t) => {
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) / angularFreq * Math.sin(angularFreq * t) + initialDelta * Math.cos(angularFreq * t));
          };
        } else if (dampingRatio === 1) {
          resolveSpring = (t) => target - Math.exp(-undampedAngularFreq * t) * (initialDelta + (initialVelocity + undampedAngularFreq * initialDelta) * t);
        } else {
          const dampedAngularFreq = undampedAngularFreq * Math.sqrt(dampingRatio * dampingRatio - 1);
          resolveSpring = (t) => {
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            const freqForT = Math.min(dampedAngularFreq * t, 300);
            return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) * Math.sinh(freqForT) + dampedAngularFreq * initialDelta * Math.cosh(freqForT)) / dampedAngularFreq;
          };
        }
        const generator = {
          calculatedDuration: isResolvedFromDuration ? duration || null : null,
          next: (t) => {
            const current = resolveSpring(t);
            if (!isResolvedFromDuration) {
              let currentVelocity = t === 0 ? initialVelocity : 0;
              if (dampingRatio < 1) {
                currentVelocity = t === 0 ? secondsToMilliseconds(initialVelocity) : calcGeneratorVelocity(resolveSpring, t, current);
              }
              const isBelowVelocityThreshold = Math.abs(currentVelocity) <= restSpeed;
              const isBelowDisplacementThreshold = Math.abs(target - current) <= restDelta;
              state.done = isBelowVelocityThreshold && isBelowDisplacementThreshold;
            } else {
              state.done = t >= duration;
            }
            state.value = state.done ? target : current;
            return state;
          },
          toString: () => {
            const calculatedDuration = Math.min(calcGeneratorDuration(generator), maxGeneratorDuration);
            const easing = generateLinearEasing((progress2) => generator.next(calculatedDuration * progress2).value, calculatedDuration, 30);
            return calculatedDuration + "ms " + easing;
          },
          toTransition: () => {
          }
        };
        return generator;
      }
      spring.applyToOptions = (options) => {
        const generatorOptions = createGeneratorEasing(options, 100, spring);
        options.ease = generatorOptions.ease;
        options.duration = secondsToMilliseconds(generatorOptions.duration);
        options.type = "keyframes";
        return options;
      };
      function inertia({ keyframes: keyframes2, velocity = 0, power = 0.8, timeConstant = 325, bounceDamping = 10, bounceStiffness = 500, modifyTarget, min, max, restDelta = 0.5, restSpeed }) {
        const origin = keyframes2[0];
        const state = {
          done: false,
          value: origin
        };
        const isOutOfBounds = (v) => min !== void 0 && v < min || max !== void 0 && v > max;
        const nearestBoundary = (v) => {
          if (min === void 0)
            return max;
          if (max === void 0)
            return min;
          return Math.abs(min - v) < Math.abs(max - v) ? min : max;
        };
        let amplitude = power * velocity;
        const ideal = origin + amplitude;
        const target = modifyTarget === void 0 ? ideal : modifyTarget(ideal);
        if (target !== ideal)
          amplitude = target - origin;
        const calcDelta = (t) => -amplitude * Math.exp(-t / timeConstant);
        const calcLatest = (t) => target + calcDelta(t);
        const applyFriction = (t) => {
          const delta = calcDelta(t);
          const latest = calcLatest(t);
          state.done = Math.abs(delta) <= restDelta;
          state.value = state.done ? target : latest;
        };
        let timeReachedBoundary;
        let spring$1;
        const checkCatchBoundary = (t) => {
          if (!isOutOfBounds(state.value))
            return;
          timeReachedBoundary = t;
          spring$1 = spring({
            keyframes: [state.value, nearestBoundary(state.value)],
            velocity: calcGeneratorVelocity(calcLatest, t, state.value),
            // TODO: This should be passing * 1000
            damping: bounceDamping,
            stiffness: bounceStiffness,
            restDelta,
            restSpeed
          });
        };
        checkCatchBoundary(0);
        return {
          calculatedDuration: null,
          next: (t) => {
            let hasUpdatedFrame = false;
            if (!spring$1 && timeReachedBoundary === void 0) {
              hasUpdatedFrame = true;
              applyFriction(t);
              checkCatchBoundary(t);
            }
            if (timeReachedBoundary !== void 0 && t >= timeReachedBoundary) {
              return spring$1.next(t - timeReachedBoundary);
            } else {
              !hasUpdatedFrame && applyFriction(t);
              return state;
            }
          }
        };
      }
      function convertOffsetToTimes(offset, duration) {
        return offset.map((o) => o * duration);
      }
      function defaultEasing(values, easing) {
        return values.map(() => easing || easeInOut).splice(0, values.length - 1);
      }
      function keyframes({ duration = 300, keyframes: keyframeValues, times, ease: ease2 = "easeInOut" }) {
        const easingFunctions = isEasingArray(ease2) ? ease2.map(easingDefinitionToFunction) : easingDefinitionToFunction(ease2);
        const state = {
          done: false,
          value: keyframeValues[0]
        };
        const absoluteTimes = convertOffsetToTimes(
          // Only use the provided offsets if they're the correct length
          // TODO Maybe we should warn here if there's a length mismatch
          times && times.length === keyframeValues.length ? times : defaultOffset(keyframeValues),
          duration
        );
        const mapTimeToKeyframe = interpolate(absoluteTimes, keyframeValues, {
          ease: Array.isArray(easingFunctions) ? easingFunctions : defaultEasing(keyframeValues, easingFunctions)
        });
        return {
          calculatedDuration: duration,
          next: (t) => {
            state.value = mapTimeToKeyframe(t);
            state.done = t >= duration;
            return state;
          }
        };
      }
      const isNotNull$1 = (value) => value !== null;
      function getFinalKeyframe$1(keyframes2, { repeat, repeatType = "loop" }, finalKeyframe, speed = 1) {
        const resolvedKeyframes = keyframes2.filter(isNotNull$1);
        const useFirstKeyframe = speed < 0 || repeat && repeatType !== "loop" && repeat % 2 === 1;
        const index = useFirstKeyframe ? 0 : resolvedKeyframes.length - 1;
        return !index || finalKeyframe === void 0 ? resolvedKeyframes[index] : finalKeyframe;
      }
      const transitionTypeMap = {
        decay: inertia,
        inertia,
        tween: keyframes,
        keyframes,
        spring
      };
      function replaceTransitionType(transition) {
        if (typeof transition.type === "string") {
          transition.type = transitionTypeMap[transition.type];
        }
      }
      class WithPromise {
        constructor() {
          this.updateFinished();
        }
        get finished() {
          return this._finished;
        }
        updateFinished() {
          this._finished = new Promise((resolve) => {
            this.resolve = resolve;
          });
        }
        notifyFinished() {
          this.resolve();
        }
        /**
         * Allows the animation to be awaited.
         *
         * @deprecated Use `finished` instead.
         */
        then(onResolve, onReject) {
          return this.finished.then(onResolve, onReject);
        }
      }
      const percentToProgress = (percent2) => percent2 / 100;
      class JSAnimation extends WithPromise {
        constructor(options) {
          super();
          this.state = "idle";
          this.startTime = null;
          this.isStopped = false;
          this.currentTime = 0;
          this.holdTime = null;
          this.playbackSpeed = 1;
          this.stop = () => {
            var _a, _b;
            const { motionValue: motionValue2 } = this.options;
            if (motionValue2 && motionValue2.updatedAt !== time.now()) {
              this.tick(time.now());
            }
            this.isStopped = true;
            if (this.state === "idle")
              return;
            this.teardown();
            (_b = (_a = this.options).onStop) == null ? void 0 : _b.call(_a);
          };
          activeAnimations.mainThread++;
          this.options = options;
          this.initAnimation();
          this.play();
          if (options.autoplay === false)
            this.pause();
        }
        initAnimation() {
          const { options } = this;
          replaceTransitionType(options);
          const { type = keyframes, repeat = 0, repeatDelay = 0, repeatType, velocity = 0 } = options;
          let { keyframes: keyframes$1 } = options;
          const generatorFactory = type || keyframes;
          if (generatorFactory !== keyframes && typeof keyframes$1[0] !== "number") {
            this.mixKeyframes = pipe(percentToProgress, mix(keyframes$1[0], keyframes$1[1]));
            keyframes$1 = [0, 100];
          }
          const generator = generatorFactory({ ...options, keyframes: keyframes$1 });
          if (repeatType === "mirror") {
            this.mirroredGenerator = generatorFactory({
              ...options,
              keyframes: [...keyframes$1].reverse(),
              velocity: -velocity
            });
          }
          if (generator.calculatedDuration === null) {
            generator.calculatedDuration = calcGeneratorDuration(generator);
          }
          const { calculatedDuration } = generator;
          this.calculatedDuration = calculatedDuration;
          this.resolvedDuration = calculatedDuration + repeatDelay;
          this.totalDuration = this.resolvedDuration * (repeat + 1) - repeatDelay;
          this.generator = generator;
        }
        updateTime(timestamp) {
          const animationTime = Math.round(timestamp - this.startTime) * this.playbackSpeed;
          if (this.holdTime !== null) {
            this.currentTime = this.holdTime;
          } else {
            this.currentTime = animationTime;
          }
        }
        tick(timestamp, sample = false) {
          const { generator, totalDuration, mixKeyframes, mirroredGenerator, resolvedDuration, calculatedDuration } = this;
          if (this.startTime === null)
            return generator.next(0);
          const { delay = 0, keyframes: keyframes2, repeat, repeatType, repeatDelay, type, onUpdate, finalKeyframe } = this.options;
          if (this.speed > 0) {
            this.startTime = Math.min(this.startTime, timestamp);
          } else if (this.speed < 0) {
            this.startTime = Math.min(timestamp - totalDuration / this.speed, this.startTime);
          }
          if (sample) {
            this.currentTime = timestamp;
          } else {
            this.updateTime(timestamp);
          }
          const timeWithoutDelay = this.currentTime - delay * (this.playbackSpeed >= 0 ? 1 : -1);
          const isInDelayPhase = this.playbackSpeed >= 0 ? timeWithoutDelay < 0 : timeWithoutDelay > totalDuration;
          this.currentTime = Math.max(timeWithoutDelay, 0);
          if (this.state === "finished" && this.holdTime === null) {
            this.currentTime = totalDuration;
          }
          let elapsed = this.currentTime;
          let frameGenerator = generator;
          if (repeat) {
            const progress2 = Math.min(this.currentTime, totalDuration) / resolvedDuration;
            let currentIteration = Math.floor(progress2);
            let iterationProgress = progress2 % 1;
            if (!iterationProgress && progress2 >= 1) {
              iterationProgress = 1;
            }
            iterationProgress === 1 && currentIteration--;
            currentIteration = Math.min(currentIteration, repeat + 1);
            const isOddIteration = Boolean(currentIteration % 2);
            if (isOddIteration) {
              if (repeatType === "reverse") {
                iterationProgress = 1 - iterationProgress;
                if (repeatDelay) {
                  iterationProgress -= repeatDelay / resolvedDuration;
                }
              } else if (repeatType === "mirror") {
                frameGenerator = mirroredGenerator;
              }
            }
            elapsed = clamp(0, 1, iterationProgress) * resolvedDuration;
          }
          const state = isInDelayPhase ? { done: false, value: keyframes2[0] } : frameGenerator.next(elapsed);
          if (mixKeyframes) {
            state.value = mixKeyframes(state.value);
          }
          let { done } = state;
          if (!isInDelayPhase && calculatedDuration !== null) {
            done = this.playbackSpeed >= 0 ? this.currentTime >= totalDuration : this.currentTime <= 0;
          }
          const isAnimationFinished = this.holdTime === null && (this.state === "finished" || this.state === "running" && done);
          if (isAnimationFinished && type !== inertia) {
            state.value = getFinalKeyframe$1(keyframes2, this.options, finalKeyframe, this.speed);
          }
          if (onUpdate) {
            onUpdate(state.value);
          }
          if (isAnimationFinished) {
            this.finish();
          }
          return state;
        }
        /**
         * Allows the returned animation to be awaited or promise-chained. Currently
         * resolves when the animation finishes at all but in a future update could/should
         * reject if its cancels.
         */
        then(resolve, reject) {
          return this.finished.then(resolve, reject);
        }
        get duration() {
          return millisecondsToSeconds(this.calculatedDuration);
        }
        get time() {
          return millisecondsToSeconds(this.currentTime);
        }
        set time(newTime) {
          var _a;
          newTime = secondsToMilliseconds(newTime);
          this.currentTime = newTime;
          if (this.startTime === null || this.holdTime !== null || this.playbackSpeed === 0) {
            this.holdTime = newTime;
          } else if (this.driver) {
            this.startTime = this.driver.now() - newTime / this.playbackSpeed;
          }
          (_a = this.driver) == null ? void 0 : _a.start(false);
        }
        get speed() {
          return this.playbackSpeed;
        }
        set speed(newSpeed) {
          this.updateTime(time.now());
          const hasChanged = this.playbackSpeed !== newSpeed;
          this.playbackSpeed = newSpeed;
          if (hasChanged) {
            this.time = millisecondsToSeconds(this.currentTime);
          }
        }
        play() {
          var _a, _b;
          if (this.isStopped)
            return;
          const { driver = frameloopDriver, startTime } = this.options;
          if (!this.driver) {
            this.driver = driver((timestamp) => this.tick(timestamp));
          }
          (_b = (_a = this.options).onPlay) == null ? void 0 : _b.call(_a);
          const now2 = this.driver.now();
          if (this.state === "finished") {
            this.updateFinished();
            this.startTime = now2;
          } else if (this.holdTime !== null) {
            this.startTime = now2 - this.holdTime;
          } else if (!this.startTime) {
            this.startTime = startTime ?? now2;
          }
          if (this.state === "finished" && this.speed < 0) {
            this.startTime += this.calculatedDuration;
          }
          this.holdTime = null;
          this.state = "running";
          this.driver.start();
        }
        pause() {
          this.state = "paused";
          this.updateTime(time.now());
          this.holdTime = this.currentTime;
        }
        complete() {
          if (this.state !== "running") {
            this.play();
          }
          this.state = "finished";
          this.holdTime = null;
        }
        finish() {
          var _a, _b;
          this.notifyFinished();
          this.teardown();
          this.state = "finished";
          (_b = (_a = this.options).onComplete) == null ? void 0 : _b.call(_a);
        }
        cancel() {
          var _a, _b;
          this.holdTime = null;
          this.startTime = 0;
          this.tick(0);
          this.teardown();
          (_b = (_a = this.options).onCancel) == null ? void 0 : _b.call(_a);
        }
        teardown() {
          this.state = "idle";
          this.stopDriver();
          this.startTime = this.holdTime = null;
          activeAnimations.mainThread--;
        }
        stopDriver() {
          if (!this.driver)
            return;
          this.driver.stop();
          this.driver = void 0;
        }
        sample(sampleTime) {
          this.startTime = 0;
          return this.tick(sampleTime, true);
        }
        attachTimeline(timeline) {
          var _a;
          if (this.options.allowFlatten) {
            this.options.type = "keyframes";
            this.options.ease = "linear";
            this.initAnimation();
          }
          (_a = this.driver) == null ? void 0 : _a.stop();
          return timeline.observe(this);
        }
      }
      exports("J", JSAnimation);
      function animateValue(options) {
        return new JSAnimation(options);
      }
      function fillWildcards(keyframes2) {
        for (let i = 1; i < keyframes2.length; i++) {
          keyframes2[i] ?? (keyframes2[i] = keyframes2[i - 1]);
        }
      }
      const radToDeg = (rad) => rad * 180 / Math.PI;
      const rotate = (v) => {
        const angle = radToDeg(Math.atan2(v[1], v[0]));
        return rebaseAngle(angle);
      };
      const matrix2dParsers = {
        x: 4,
        y: 5,
        translateX: 4,
        translateY: 5,
        scaleX: 0,
        scaleY: 3,
        scale: (v) => (Math.abs(v[0]) + Math.abs(v[3])) / 2,
        rotate,
        rotateZ: rotate,
        skewX: (v) => radToDeg(Math.atan(v[1])),
        skewY: (v) => radToDeg(Math.atan(v[2])),
        skew: (v) => (Math.abs(v[1]) + Math.abs(v[2])) / 2
      };
      const rebaseAngle = (angle) => {
        angle = angle % 360;
        if (angle < 0)
          angle += 360;
        return angle;
      };
      const rotateZ = rotate;
      const scaleX = (v) => Math.sqrt(v[0] * v[0] + v[1] * v[1]);
      const scaleY = (v) => Math.sqrt(v[4] * v[4] + v[5] * v[5]);
      const matrix3dParsers = {
        x: 12,
        y: 13,
        z: 14,
        translateX: 12,
        translateY: 13,
        translateZ: 14,
        scaleX,
        scaleY,
        scale: (v) => (scaleX(v) + scaleY(v)) / 2,
        rotateX: (v) => rebaseAngle(radToDeg(Math.atan2(v[6], v[5]))),
        rotateY: (v) => rebaseAngle(radToDeg(Math.atan2(-v[2], v[0]))),
        rotateZ,
        rotate: rotateZ,
        skewX: (v) => radToDeg(Math.atan(v[4])),
        skewY: (v) => radToDeg(Math.atan(v[1])),
        skew: (v) => (Math.abs(v[1]) + Math.abs(v[4])) / 2
      };
      function defaultTransformValue(name) {
        return name.includes("scale") ? 1 : 0;
      }
      function parseValueFromTransform(transform, name) {
        if (!transform || transform === "none") {
          return defaultTransformValue(name);
        }
        const matrix3dMatch = transform.match(/^matrix3d\(([-\d.e\s,]+)\)$/u);
        let parsers;
        let match;
        if (matrix3dMatch) {
          parsers = matrix3dParsers;
          match = matrix3dMatch;
        } else {
          const matrix2dMatch = transform.match(/^matrix\(([-\d.e\s,]+)\)$/u);
          parsers = matrix2dParsers;
          match = matrix2dMatch;
        }
        if (!match) {
          return defaultTransformValue(name);
        }
        const valueParser = parsers[name];
        const values = match[1].split(",").map(convertTransformToNumber);
        return typeof valueParser === "function" ? valueParser(values) : values[valueParser];
      }
      const readTransformValue = exports("$", (instance, name) => {
        const { transform = "none" } = getComputedStyle(instance);
        return parseValueFromTransform(transform, name);
      });
      function convertTransformToNumber(value) {
        return parseFloat(value.trim());
      }
      const transformPropOrder = exports("t", [
        "transformPerspective",
        "x",
        "y",
        "z",
        "translateX",
        "translateY",
        "translateZ",
        "scale",
        "scaleX",
        "scaleY",
        "rotate",
        "rotateX",
        "rotateY",
        "rotateZ",
        "skew",
        "skewX",
        "skewY"
      ]);
      const transformProps = exports("c", /* @__PURE__ */ (() => new Set(transformPropOrder))());
      const isNumOrPxType = (v) => v === number || v === px;
      const transformKeys = /* @__PURE__ */ new Set(["x", "y", "z"]);
      const nonTranslationalTransformKeys = transformPropOrder.filter((key) => !transformKeys.has(key));
      function removeNonTranslationalTransform(visualElement) {
        const removedTransforms = [];
        nonTranslationalTransformKeys.forEach((key) => {
          const value = visualElement.getValue(key);
          if (value !== void 0) {
            removedTransforms.push([key, value.get()]);
            value.set(key.startsWith("scale") ? 1 : 0);
          }
        });
        return removedTransforms;
      }
      const positionalValues = {
        // Dimensions
        width: ({ x }, { paddingLeft = "0", paddingRight = "0" }) => x.max - x.min - parseFloat(paddingLeft) - parseFloat(paddingRight),
        height: ({ y }, { paddingTop = "0", paddingBottom = "0" }) => y.max - y.min - parseFloat(paddingTop) - parseFloat(paddingBottom),
        top: (_bbox, { top }) => parseFloat(top),
        left: (_bbox, { left }) => parseFloat(left),
        bottom: ({ y }, { top }) => parseFloat(top) + (y.max - y.min),
        right: ({ x }, { left }) => parseFloat(left) + (x.max - x.min),
        // Transform
        x: (_bbox, { transform }) => parseValueFromTransform(transform, "x"),
        y: (_bbox, { transform }) => parseValueFromTransform(transform, "y")
      };
      positionalValues.translateX = positionalValues.x;
      positionalValues.translateY = positionalValues.y;
      const toResolve = /* @__PURE__ */ new Set();
      let isScheduled = false;
      let anyNeedsMeasurement = false;
      let isForced = false;
      function measureAllKeyframes() {
        if (anyNeedsMeasurement) {
          const resolversToMeasure = Array.from(toResolve).filter((resolver) => resolver.needsMeasurement);
          const elementsToMeasure = new Set(resolversToMeasure.map((resolver) => resolver.element));
          const transformsToRestore = /* @__PURE__ */ new Map();
          elementsToMeasure.forEach((element) => {
            const removedTransforms = removeNonTranslationalTransform(element);
            if (!removedTransforms.length)
              return;
            transformsToRestore.set(element, removedTransforms);
            element.render();
          });
          resolversToMeasure.forEach((resolver) => resolver.measureInitialState());
          elementsToMeasure.forEach((element) => {
            element.render();
            const restore = transformsToRestore.get(element);
            if (restore) {
              restore.forEach(([key, value]) => {
                var _a;
                (_a = element.getValue(key)) == null ? void 0 : _a.set(value);
              });
            }
          });
          resolversToMeasure.forEach((resolver) => resolver.measureEndState());
          resolversToMeasure.forEach((resolver) => {
            if (resolver.suspendedScrollY !== void 0) {
              window.scrollTo(0, resolver.suspendedScrollY);
            }
          });
        }
        anyNeedsMeasurement = false;
        isScheduled = false;
        toResolve.forEach((resolver) => resolver.complete(isForced));
        toResolve.clear();
      }
      function readAllKeyframes() {
        toResolve.forEach((resolver) => {
          resolver.readKeyframes();
          if (resolver.needsMeasurement) {
            anyNeedsMeasurement = true;
          }
        });
      }
      function flushKeyframeResolvers() {
        isForced = true;
        readAllKeyframes();
        measureAllKeyframes();
        isForced = false;
      }
      class KeyframeResolver {
        constructor(unresolvedKeyframes, onComplete, name, motionValue2, element, isAsync = false) {
          this.state = "pending";
          this.isAsync = false;
          this.needsMeasurement = false;
          this.unresolvedKeyframes = [...unresolvedKeyframes];
          this.onComplete = onComplete;
          this.name = name;
          this.motionValue = motionValue2;
          this.element = element;
          this.isAsync = isAsync;
        }
        scheduleResolve() {
          this.state = "scheduled";
          if (this.isAsync) {
            toResolve.add(this);
            if (!isScheduled) {
              isScheduled = true;
              frame.read(readAllKeyframes);
              frame.resolveKeyframes(measureAllKeyframes);
            }
          } else {
            this.readKeyframes();
            this.complete();
          }
        }
        readKeyframes() {
          const { unresolvedKeyframes, name, element, motionValue: motionValue2 } = this;
          if (unresolvedKeyframes[0] === null) {
            const currentValue = motionValue2 == null ? void 0 : motionValue2.get();
            const finalKeyframe = unresolvedKeyframes[unresolvedKeyframes.length - 1];
            if (currentValue !== void 0) {
              unresolvedKeyframes[0] = currentValue;
            } else if (element && name) {
              const valueAsRead = element.readValue(name, finalKeyframe);
              if (valueAsRead !== void 0 && valueAsRead !== null) {
                unresolvedKeyframes[0] = valueAsRead;
              }
            }
            if (unresolvedKeyframes[0] === void 0) {
              unresolvedKeyframes[0] = finalKeyframe;
            }
            if (motionValue2 && currentValue === void 0) {
              motionValue2.set(unresolvedKeyframes[0]);
            }
          }
          fillWildcards(unresolvedKeyframes);
        }
        setFinalKeyframe() {
        }
        measureInitialState() {
        }
        renderEndStyles() {
        }
        measureEndState() {
        }
        complete(isForcedComplete = false) {
          this.state = "complete";
          this.onComplete(this.unresolvedKeyframes, this.finalKeyframe, isForcedComplete);
          toResolve.delete(this);
        }
        cancel() {
          if (this.state === "scheduled") {
            toResolve.delete(this);
            this.state = "pending";
          }
        }
        resume() {
          if (this.state === "pending")
            this.scheduleResolve();
        }
      }
      exports("R", KeyframeResolver);
      const isCSSVar = exports("d", (name) => name.startsWith("--"));
      function setStyle(element, name, value) {
        isCSSVar(name) ? element.style.setProperty(name, value) : element.style[name] = value;
      }
      const supportsFlags = exports("a3", {});
      function memoSupports(callback, supportsFlag) {
        const memoized = memo(callback);
        return () => supportsFlags[supportsFlag] ?? memoized();
      }
      const supportsLinearEasing = exports("s", /* @__PURE__ */ memoSupports(() => {
        try {
          document.createElement("div").animate({ opacity: 0 }, { easing: "linear(0, 1)" });
        } catch (e) {
          return false;
        }
        return true;
      }, "linearEasing"));
      const cubicBezierAsString = exports("U", ([a, b, c, d]) => `cubic-bezier(${a}, ${b}, ${c}, ${d})`);
      const supportedWaapiEasing = exports("b", {
        linear: "linear",
        ease: "ease",
        easeIn: "ease-in",
        easeOut: "ease-out",
        easeInOut: "ease-in-out",
        circIn: /* @__PURE__ */ cubicBezierAsString([0, 0.65, 0.55, 1]),
        circOut: /* @__PURE__ */ cubicBezierAsString([0.55, 0, 1, 0.45]),
        backIn: /* @__PURE__ */ cubicBezierAsString([0.31, 0.01, 0.66, -0.59]),
        backOut: /* @__PURE__ */ cubicBezierAsString([0.33, 1.53, 0.69, 0.99])
      });
      function mapEasingToNativeEasing(easing, duration) {
        if (!easing) {
          return void 0;
        } else if (typeof easing === "function") {
          return supportsLinearEasing() ? generateLinearEasing(easing, duration) : "ease-out";
        } else if (isBezierDefinition(easing)) {
          return cubicBezierAsString(easing);
        } else if (Array.isArray(easing)) {
          return easing.map((segmentEasing) => mapEasingToNativeEasing(segmentEasing, duration) || supportedWaapiEasing.easeOut);
        } else {
          return supportedWaapiEasing[easing];
        }
      }
      function startWaapiAnimation(element, valueName, keyframes2, { delay = 0, duration = 300, repeat = 0, repeatType = "loop", ease: ease2 = "easeOut", times } = {}, pseudoElement = void 0) {
        const keyframeOptions = {
          [valueName]: keyframes2
        };
        if (times)
          keyframeOptions.offset = times;
        const easing = mapEasingToNativeEasing(ease2, duration);
        if (Array.isArray(easing))
          keyframeOptions.easing = easing;
        if (statsBuffer.value) {
          activeAnimations.waapi++;
        }
        const options = {
          delay,
          duration,
          easing: !Array.isArray(easing) ? easing : "linear",
          fill: "both",
          iterations: repeat + 1,
          direction: repeatType === "reverse" ? "alternate" : "normal"
        };
        if (pseudoElement)
          options.pseudoElement = pseudoElement;
        const animation = element.animate(keyframeOptions, options);
        if (statsBuffer.value) {
          animation.finished.finally(() => {
            activeAnimations.waapi--;
          });
        }
        return animation;
      }
      function isGenerator(type) {
        return typeof type === "function" && "applyToOptions" in type;
      }
      function applyGeneratorOptions({ type, ...options }) {
        if (isGenerator(type) && supportsLinearEasing()) {
          return type.applyToOptions(options);
        } else {
          options.duration ?? (options.duration = 300);
          options.ease ?? (options.ease = "easeOut");
        }
        return options;
      }
      class NativeAnimation extends WithPromise {
        constructor(options) {
          super();
          this.finishedTime = null;
          this.isStopped = false;
          if (!options)
            return;
          const { element, name, keyframes: keyframes2, pseudoElement, allowFlatten = false, finalKeyframe, onComplete } = options;
          this.isPseudoElement = Boolean(pseudoElement);
          this.allowFlatten = allowFlatten;
          this.options = options;
          invariant(typeof options.type !== "string");
          const transition = applyGeneratorOptions(options);
          this.animation = startWaapiAnimation(element, name, keyframes2, transition, pseudoElement);
          if (transition.autoplay === false) {
            this.animation.pause();
          }
          this.animation.onfinish = () => {
            this.finishedTime = this.time;
            if (!pseudoElement) {
              const keyframe = getFinalKeyframe$1(keyframes2, this.options, finalKeyframe, this.speed);
              if (this.updateMotionValue) {
                this.updateMotionValue(keyframe);
              } else {
                setStyle(element, name, keyframe);
              }
              this.animation.cancel();
            }
            onComplete == null ? void 0 : onComplete();
            this.notifyFinished();
          };
        }
        play() {
          if (this.isStopped)
            return;
          this.animation.play();
          if (this.state === "finished") {
            this.updateFinished();
          }
        }
        pause() {
          this.animation.pause();
        }
        complete() {
          var _a, _b;
          (_b = (_a = this.animation).finish) == null ? void 0 : _b.call(_a);
        }
        cancel() {
          try {
            this.animation.cancel();
          } catch (e) {
          }
        }
        stop() {
          if (this.isStopped)
            return;
          this.isStopped = true;
          const { state } = this;
          if (state === "idle" || state === "finished") {
            return;
          }
          if (this.updateMotionValue) {
            this.updateMotionValue();
          } else {
            this.commitStyles();
          }
          if (!this.isPseudoElement)
            this.cancel();
        }
        /**
         * WAAPI doesn't natively have any interruption capabilities.
         *
         * In this method, we commit styles back to the DOM before cancelling
         * the animation.
         *
         * This is designed to be overridden by NativeAnimationExtended, which
         * will create a renderless JS animation and sample it twice to calculate
         * its current value, "previous" value, and therefore allow
         * Motion to also correctly calculate velocity for any subsequent animation
         * while deferring the commit until the next animation frame.
         */
        commitStyles() {
          var _a, _b;
          if (!this.isPseudoElement) {
            (_b = (_a = this.animation).commitStyles) == null ? void 0 : _b.call(_a);
          }
        }
        get duration() {
          var _a, _b;
          const duration = ((_b = (_a = this.animation.effect) == null ? void 0 : _a.getComputedTiming) == null ? void 0 : _b.call(_a).duration) || 0;
          return millisecondsToSeconds(Number(duration));
        }
        get time() {
          return millisecondsToSeconds(Number(this.animation.currentTime) || 0);
        }
        set time(newTime) {
          this.finishedTime = null;
          this.animation.currentTime = secondsToMilliseconds(newTime);
        }
        /**
         * The playback speed of the animation.
         * 1 = normal speed, 2 = double speed, 0.5 = half speed.
         */
        get speed() {
          return this.animation.playbackRate;
        }
        set speed(newSpeed) {
          if (newSpeed < 0)
            this.finishedTime = null;
          this.animation.playbackRate = newSpeed;
        }
        get state() {
          return this.finishedTime !== null ? "finished" : this.animation.playState;
        }
        get startTime() {
          return Number(this.animation.startTime);
        }
        set startTime(newStartTime) {
          this.animation.startTime = newStartTime;
        }
        /**
         * Attaches a timeline to the animation, for instance the `ScrollTimeline`.
         */
        attachTimeline({ timeline, observe }) {
          var _a;
          if (this.allowFlatten) {
            (_a = this.animation.effect) == null ? void 0 : _a.updateTiming({ easing: "linear" });
          }
          this.animation.onfinish = null;
          if (timeline && supportsScrollTimeline()) {
            this.animation.timeline = timeline;
            return noop;
          } else {
            return observe(this);
          }
        }
      }
      exports("N", NativeAnimation);
      const unsupportedEasingFunctions = {
        anticipate,
        backInOut,
        circInOut
      };
      function isUnsupportedEase(key) {
        return key in unsupportedEasingFunctions;
      }
      function replaceStringEasing(transition) {
        if (typeof transition.ease === "string" && isUnsupportedEase(transition.ease)) {
          transition.ease = unsupportedEasingFunctions[transition.ease];
        }
      }
      const sampleDelta = 10;
      class NativeAnimationExtended extends NativeAnimation {
        constructor(options) {
          replaceStringEasing(options);
          replaceTransitionType(options);
          super(options);
          if (options.startTime) {
            this.startTime = options.startTime;
          }
          this.options = options;
        }
        /**
         * WAAPI doesn't natively have any interruption capabilities.
         *
         * Rather than read commited styles back out of the DOM, we can
         * create a renderless JS animation and sample it twice to calculate
         * its current value, "previous" value, and therefore allow
         * Motion to calculate velocity for any subsequent animation.
         */
        updateMotionValue(value) {
          const { motionValue: motionValue2, onUpdate, onComplete, element, ...options } = this.options;
          if (!motionValue2)
            return;
          if (value !== void 0) {
            motionValue2.set(value);
            return;
          }
          const sampleAnimation = new JSAnimation({
            ...options,
            autoplay: false
          });
          const sampleTime = secondsToMilliseconds(this.finishedTime ?? this.time);
          motionValue2.setWithVelocity(sampleAnimation.sample(sampleTime - sampleDelta).value, sampleAnimation.sample(sampleTime).value, sampleDelta);
          sampleAnimation.stop();
        }
      }
      exports("z", NativeAnimationExtended);
      const isAnimatable = (value, name) => {
        if (name === "zIndex")
          return false;
        if (typeof value === "number" || Array.isArray(value))
          return true;
        if (typeof value === "string" && // It's animatable if we have a string
        (complex.test(value) || value === "0") && // And it contains numbers and/or colors
        !value.startsWith("url(")) {
          return true;
        }
        return false;
      };
      function hasKeyframesChanged(keyframes2) {
        const current = keyframes2[0];
        if (keyframes2.length === 1)
          return true;
        for (let i = 0; i < keyframes2.length; i++) {
          if (keyframes2[i] !== current)
            return true;
        }
      }
      function canAnimate(keyframes2, name, type, velocity) {
        const originKeyframe = keyframes2[0];
        if (originKeyframe === null)
          return false;
        if (name === "display" || name === "visibility")
          return true;
        const targetKeyframe = keyframes2[keyframes2.length - 1];
        const isOriginAnimatable = isAnimatable(originKeyframe, name);
        const isTargetAnimatable = isAnimatable(targetKeyframe, name);
        if (!isOriginAnimatable || !isTargetAnimatable) {
          return false;
        }
        return hasKeyframesChanged(keyframes2) || (type === "spring" || isGenerator(type)) && velocity;
      }
      function makeAnimationInstant(options) {
        options.duration = 0;
        options.type === "keyframes";
      }
      const acceleratedValues = /* @__PURE__ */ new Set([
        "opacity",
        "clipPath",
        "filter",
        "transform"
        // TODO: Could be re-enabled now we have support for linear() easing
        // "background-color"
      ]);
      const supportsWaapi = /* @__PURE__ */ memo(() => Object.hasOwnProperty.call(Element.prototype, "animate"));
      function supportsBrowserAnimation(options) {
        var _a;
        const { motionValue: motionValue2, name, repeatDelay, repeatType, damping, type } = options;
        const subject = (_a = motionValue2 == null ? void 0 : motionValue2.owner) == null ? void 0 : _a.current;
        if (!(subject instanceof HTMLElement)) {
          return false;
        }
        const { onUpdate, transformTemplate } = motionValue2.owner.getProps();
        return supportsWaapi() && name && acceleratedValues.has(name) && (name !== "transform" || !transformTemplate) && /**
         * If we're outputting values to onUpdate then we can't use WAAPI as there's
         * no way to read the value from WAAPI every frame.
         */
        !onUpdate && !repeatDelay && repeatType !== "mirror" && damping !== 0 && type !== "inertia";
      }
      const MAX_RESOLVE_DELAY = 40;
      class AsyncMotionValueAnimation extends WithPromise {
        constructor({ autoplay = true, delay = 0, type = "keyframes", repeat = 0, repeatDelay = 0, repeatType = "loop", keyframes: keyframes2, name, motionValue: motionValue2, element, ...options }) {
          var _a;
          super();
          this.stop = () => {
            var _a2, _b;
            if (this._animation) {
              this._animation.stop();
              (_a2 = this.stopTimeline) == null ? void 0 : _a2.call(this);
            }
            (_b = this.keyframeResolver) == null ? void 0 : _b.cancel();
          };
          this.createdAt = time.now();
          const optionsWithDefaults = {
            autoplay,
            delay,
            type,
            repeat,
            repeatDelay,
            repeatType,
            name,
            motionValue: motionValue2,
            element,
            ...options
          };
          const KeyframeResolver$1 = (element == null ? void 0 : element.KeyframeResolver) || KeyframeResolver;
          this.keyframeResolver = new KeyframeResolver$1(keyframes2, (resolvedKeyframes, finalKeyframe, forced) => this.onKeyframesResolved(resolvedKeyframes, finalKeyframe, optionsWithDefaults, !forced), name, motionValue2, element);
          (_a = this.keyframeResolver) == null ? void 0 : _a.scheduleResolve();
        }
        onKeyframesResolved(keyframes2, finalKeyframe, options, sync) {
          this.keyframeResolver = void 0;
          const { name, type, velocity, delay, isHandoff, onUpdate } = options;
          this.resolvedAt = time.now();
          if (!canAnimate(keyframes2, name, type, velocity)) {
            if (MotionGlobalConfig.instantAnimations || !delay) {
              onUpdate == null ? void 0 : onUpdate(getFinalKeyframe$1(keyframes2, options, finalKeyframe));
            }
            keyframes2[0] = keyframes2[keyframes2.length - 1];
            makeAnimationInstant(options);
            options.repeat = 0;
          }
          const startTime = sync ? !this.resolvedAt ? this.createdAt : this.resolvedAt - this.createdAt > MAX_RESOLVE_DELAY ? this.resolvedAt : this.createdAt : void 0;
          const resolvedOptions = {
            startTime,
            finalKeyframe,
            ...options,
            keyframes: keyframes2
          };
          const animation = !isHandoff && supportsBrowserAnimation(resolvedOptions) ? new NativeAnimationExtended({
            ...resolvedOptions,
            element: resolvedOptions.motionValue.owner.current
          }) : new JSAnimation(resolvedOptions);
          animation.finished.then(() => this.notifyFinished()).catch(noop);
          if (this.pendingTimeline) {
            this.stopTimeline = animation.attachTimeline(this.pendingTimeline);
            this.pendingTimeline = void 0;
          }
          this._animation = animation;
        }
        get finished() {
          if (!this._animation) {
            return this._finished;
          } else {
            return this.animation.finished;
          }
        }
        then(onResolve, _onReject) {
          return this.finished.finally(onResolve).then(() => {
          });
        }
        get animation() {
          var _a;
          if (!this._animation) {
            (_a = this.keyframeResolver) == null ? void 0 : _a.resume();
            flushKeyframeResolvers();
          }
          return this._animation;
        }
        get duration() {
          return this.animation.duration;
        }
        get time() {
          return this.animation.time;
        }
        set time(newTime) {
          this.animation.time = newTime;
        }
        get speed() {
          return this.animation.speed;
        }
        get state() {
          return this.animation.state;
        }
        set speed(newSpeed) {
          this.animation.speed = newSpeed;
        }
        get startTime() {
          return this.animation.startTime;
        }
        attachTimeline(timeline) {
          if (this._animation) {
            this.stopTimeline = this.animation.attachTimeline(timeline);
          } else {
            this.pendingTimeline = timeline;
          }
          return () => this.stop();
        }
        play() {
          this.animation.play();
        }
        pause() {
          this.animation.pause();
        }
        complete() {
          this.animation.complete();
        }
        cancel() {
          var _a;
          if (this._animation) {
            this.animation.cancel();
          }
          (_a = this.keyframeResolver) == null ? void 0 : _a.cancel();
        }
      }
      exports("A", AsyncMotionValueAnimation);
      class GroupAnimation {
        constructor(animations) {
          this.stop = () => this.runAll("stop");
          this.animations = animations.filter(Boolean);
        }
        get finished() {
          return Promise.all(this.animations.map((animation) => animation.finished));
        }
        /**
         * TODO: Filter out cancelled or stopped animations before returning
         */
        getAll(propName) {
          return this.animations[0][propName];
        }
        setAll(propName, newValue) {
          for (let i = 0; i < this.animations.length; i++) {
            this.animations[i][propName] = newValue;
          }
        }
        attachTimeline(timeline) {
          const subscriptions = this.animations.map((animation) => animation.attachTimeline(timeline));
          return () => {
            subscriptions.forEach((cancel, i) => {
              cancel && cancel();
              this.animations[i].stop();
            });
          };
        }
        get time() {
          return this.getAll("time");
        }
        set time(time2) {
          this.setAll("time", time2);
        }
        get speed() {
          return this.getAll("speed");
        }
        set speed(speed) {
          this.setAll("speed", speed);
        }
        get state() {
          return this.getAll("state");
        }
        get startTime() {
          return this.getAll("startTime");
        }
        get duration() {
          let max = 0;
          for (let i = 0; i < this.animations.length; i++) {
            max = Math.max(max, this.animations[i].duration);
          }
          return max;
        }
        runAll(methodName) {
          this.animations.forEach((controls) => controls[methodName]());
        }
        play() {
          this.runAll("play");
        }
        pause() {
          this.runAll("pause");
        }
        cancel() {
          this.runAll("cancel");
        }
        complete() {
          this.runAll("complete");
        }
      }
      exports("G", GroupAnimation);
      class GroupAnimationWithThen extends GroupAnimation {
        then(onResolve, _onReject) {
          return this.finished.finally(onResolve).then(() => {
          });
        }
      }
      exports("v", GroupAnimationWithThen);
      const splitCSSVariableRegex = (
        // eslint-disable-next-line redos-detector/no-unsafe-regex -- false positive, as it can match a lot of words
        /^var\(--(?:([\w-]+)|([\w-]+), ?([a-zA-Z\d ()%#.,-]+))\)/u
      );
      function parseCSSVariable(current) {
        const match = splitCSSVariableRegex.exec(current);
        if (!match)
          return [,];
        const [, token1, token2, fallback] = match;
        return [`--${token1 ?? token2}`, fallback];
      }
      function getVariableValue(current, element, depth = 1) {
        const [token, fallback] = parseCSSVariable(current);
        if (!token)
          return;
        const resolved = window.getComputedStyle(element).getPropertyValue(token);
        if (resolved) {
          const trimmed = resolved.trim();
          return isNumericalString(trimmed) ? parseFloat(trimmed) : trimmed;
        }
        return isCSSVariableToken(fallback) ? getVariableValue(fallback, element, depth + 1) : fallback;
      }
      function getValueTransition$1(transition, key) {
        return (transition == null ? void 0 : transition[key]) ?? (transition == null ? void 0 : transition["default"]) ?? transition;
      }
      const positionalKeys = exports("a1", /* @__PURE__ */ new Set([
        "width",
        "height",
        "top",
        "left",
        "right",
        "bottom",
        ...transformPropOrder
      ]));
      const auto = {
        test: (v) => v === "auto",
        parse: (v) => v
      };
      const testValueType = exports("a9", (v) => (type) => type.test(v));
      const dimensionValueTypes = exports("a4", [number, px, percent, degrees, vw, vh, auto]);
      const findDimensionValueType = exports("a5", (v) => dimensionValueTypes.find(testValueType(v)));
      function isNone(value) {
        if (typeof value === "number") {
          return value === 0;
        } else if (value !== null) {
          return value === "none" || value === "0" || isZeroValueString(value);
        } else {
          return true;
        }
      }
      const maxDefaults = /* @__PURE__ */ new Set(["brightness", "contrast", "saturate", "opacity"]);
      function applyDefaultFilter(v) {
        const [name, value] = v.slice(0, -1).split("(");
        if (name === "drop-shadow")
          return v;
        const [number2] = value.match(floatRegex) || [];
        if (!number2)
          return v;
        const unit = value.replace(number2, "");
        let defaultValue = maxDefaults.has(name) ? 1 : 0;
        if (number2 !== value)
          defaultValue *= 100;
        return name + "(" + defaultValue + unit + ")";
      }
      const functionRegex = /\b([a-z-]*)\(.*?\)/gu;
      const filter = {
        ...complex,
        getAnimatableNone: (v) => {
          const functions = v.match(functionRegex);
          return functions ? functions.map(applyDefaultFilter).join(" ") : v;
        }
      };
      const int = {
        ...number,
        transform: Math.round
      };
      const transformValueTypes = exports("a8", {
        rotate: degrees,
        rotateX: degrees,
        rotateY: degrees,
        rotateZ: degrees,
        scale,
        scaleX: scale,
        scaleY: scale,
        scaleZ: scale,
        skew: degrees,
        skewX: degrees,
        skewY: degrees,
        distance: px,
        translateX: px,
        translateY: px,
        translateZ: px,
        x: px,
        y: px,
        z: px,
        perspective: px,
        transformPerspective: px,
        opacity: alpha,
        originX: progressPercentage,
        originY: progressPercentage,
        originZ: px
      });
      const numberValueTypes = exports("n", {
        // Border props
        borderWidth: px,
        borderTopWidth: px,
        borderRightWidth: px,
        borderBottomWidth: px,
        borderLeftWidth: px,
        borderRadius: px,
        radius: px,
        borderTopLeftRadius: px,
        borderTopRightRadius: px,
        borderBottomRightRadius: px,
        borderBottomLeftRadius: px,
        // Positioning props
        width: px,
        maxWidth: px,
        height: px,
        maxHeight: px,
        top: px,
        right: px,
        bottom: px,
        left: px,
        // Spacing props
        padding: px,
        paddingTop: px,
        paddingRight: px,
        paddingBottom: px,
        paddingLeft: px,
        margin: px,
        marginTop: px,
        marginRight: px,
        marginBottom: px,
        marginLeft: px,
        // Misc
        backgroundPositionX: px,
        backgroundPositionY: px,
        ...transformValueTypes,
        zIndex: int,
        // SVG
        fillOpacity: alpha,
        strokeOpacity: alpha,
        numOctaves: int
      });
      const defaultValueTypes = exports("a6", {
        ...numberValueTypes,
        // Color props
        color,
        backgroundColor: color,
        outlineColor: color,
        fill: color,
        stroke: color,
        // Border props
        borderColor: color,
        borderTopColor: color,
        borderRightColor: color,
        borderBottomColor: color,
        borderLeftColor: color,
        filter,
        WebkitFilter: filter
      });
      const getDefaultValueType = exports("a7", (key) => defaultValueTypes[key]);
      function getAnimatableNone(key, value) {
        let defaultValueType = getDefaultValueType(key);
        if (defaultValueType !== filter)
          defaultValueType = complex;
        return defaultValueType.getAnimatableNone ? defaultValueType.getAnimatableNone(value) : void 0;
      }
      const invalidTemplates = /* @__PURE__ */ new Set(["auto", "none", "0"]);
      function makeNoneKeyframesAnimatable(unresolvedKeyframes, noneKeyframeIndexes, name) {
        let i = 0;
        let animatableTemplate = void 0;
        while (i < unresolvedKeyframes.length && !animatableTemplate) {
          const keyframe = unresolvedKeyframes[i];
          if (typeof keyframe === "string" && !invalidTemplates.has(keyframe) && analyseComplexValue(keyframe).values.length) {
            animatableTemplate = unresolvedKeyframes[i];
          }
          i++;
        }
        if (animatableTemplate && name) {
          for (const noneIndex of noneKeyframeIndexes) {
            unresolvedKeyframes[noneIndex] = getAnimatableNone(name, animatableTemplate);
          }
        }
      }
      class DOMKeyframesResolver extends KeyframeResolver {
        constructor(unresolvedKeyframes, onComplete, name, motionValue2, element) {
          super(unresolvedKeyframes, onComplete, name, motionValue2, element, true);
        }
        readKeyframes() {
          const { unresolvedKeyframes, element, name } = this;
          if (!element || !element.current)
            return;
          super.readKeyframes();
          for (let i = 0; i < unresolvedKeyframes.length; i++) {
            let keyframe = unresolvedKeyframes[i];
            if (typeof keyframe === "string") {
              keyframe = keyframe.trim();
              if (isCSSVariableToken(keyframe)) {
                const resolved = getVariableValue(keyframe, element.current);
                if (resolved !== void 0) {
                  unresolvedKeyframes[i] = resolved;
                }
                if (i === unresolvedKeyframes.length - 1) {
                  this.finalKeyframe = keyframe;
                }
              }
            }
          }
          this.resolveNoneKeyframes();
          if (!positionalKeys.has(name) || unresolvedKeyframes.length !== 2) {
            return;
          }
          const [origin, target] = unresolvedKeyframes;
          const originType = findDimensionValueType(origin);
          const targetType = findDimensionValueType(target);
          if (originType === targetType)
            return;
          if (isNumOrPxType(originType) && isNumOrPxType(targetType)) {
            for (let i = 0; i < unresolvedKeyframes.length; i++) {
              const value = unresolvedKeyframes[i];
              if (typeof value === "string") {
                unresolvedKeyframes[i] = parseFloat(value);
              }
            }
          } else if (positionalValues[name]) {
            this.needsMeasurement = true;
          }
        }
        resolveNoneKeyframes() {
          const { unresolvedKeyframes, name } = this;
          const noneKeyframeIndexes = [];
          for (let i = 0; i < unresolvedKeyframes.length; i++) {
            if (unresolvedKeyframes[i] === null || isNone(unresolvedKeyframes[i])) {
              noneKeyframeIndexes.push(i);
            }
          }
          if (noneKeyframeIndexes.length) {
            makeNoneKeyframesAnimatable(unresolvedKeyframes, noneKeyframeIndexes, name);
          }
        }
        measureInitialState() {
          const { element, unresolvedKeyframes, name } = this;
          if (!element || !element.current)
            return;
          if (name === "height") {
            this.suspendedScrollY = window.pageYOffset;
          }
          this.measuredOrigin = positionalValues[name](element.measureViewportBox(), window.getComputedStyle(element.current));
          unresolvedKeyframes[0] = this.measuredOrigin;
          const measureKeyframe = unresolvedKeyframes[unresolvedKeyframes.length - 1];
          if (measureKeyframe !== void 0) {
            element.getValue(name, measureKeyframe).jump(measureKeyframe, false);
          }
        }
        measureEndState() {
          var _a;
          const { element, name, unresolvedKeyframes } = this;
          if (!element || !element.current)
            return;
          const value = element.getValue(name);
          value && value.jump(this.measuredOrigin, false);
          const finalKeyframeIndex = unresolvedKeyframes.length - 1;
          const finalKeyframe = unresolvedKeyframes[finalKeyframeIndex];
          unresolvedKeyframes[finalKeyframeIndex] = positionalValues[name](element.measureViewportBox(), window.getComputedStyle(element.current));
          if (finalKeyframe !== null && this.finalKeyframe === void 0) {
            this.finalKeyframe = finalKeyframe;
          }
          if ((_a = this.removedTransforms) == null ? void 0 : _a.length) {
            this.removedTransforms.forEach(([unsetTransformName, unsetTransformValue]) => {
              element.getValue(unsetTransformName).set(unsetTransformValue);
            });
          }
          this.resolveNoneKeyframes();
        }
      }
      exports("Q", DOMKeyframesResolver);
      const getValueAsType = exports("g", (value, type) => {
        return type && typeof value === "number" ? type.transform(value) : value;
      });
      const MAX_VELOCITY_DELTA = 30;
      const isFloat = (value) => {
        return !isNaN(parseFloat(value));
      };
      const collectMotionValues = exports("h", {
        current: void 0
      });
      class MotionValue {
        /**
         * @param init - The initiating value
         * @param config - Optional configuration options
         *
         * -  `transformer`: A function to transform incoming values with.
         */
        constructor(init, options = {}) {
          this.canTrackVelocity = null;
          this.events = {};
          this.updateAndNotify = (v) => {
            var _a;
            const currentTime = time.now();
            if (this.updatedAt !== currentTime) {
              this.setPrevFrameValue();
            }
            this.prev = this.current;
            this.setCurrent(v);
            if (this.current !== this.prev) {
              (_a = this.events.change) == null ? void 0 : _a.notify(this.current);
              if (this.dependents) {
                for (const dependent of this.dependents) {
                  dependent.dirty();
                }
              }
            }
          };
          this.hasAnimated = false;
          this.setCurrent(init);
          this.owner = options.owner;
        }
        setCurrent(current) {
          this.current = current;
          this.updatedAt = time.now();
          if (this.canTrackVelocity === null && current !== void 0) {
            this.canTrackVelocity = isFloat(this.current);
          }
        }
        setPrevFrameValue(prevFrameValue = this.current) {
          this.prevFrameValue = prevFrameValue;
          this.prevUpdatedAt = this.updatedAt;
        }
        /**
         * Adds a function that will be notified when the `MotionValue` is updated.
         *
         * It returns a function that, when called, will cancel the subscription.
         *
         * When calling `onChange` inside a React component, it should be wrapped with the
         * `useEffect` hook. As it returns an unsubscribe function, this should be returned
         * from the `useEffect` function to ensure you don't add duplicate subscribers..
         *
         * ```jsx
         * export const MyComponent = () => {
         *   const x = useMotionValue(0)
         *   const y = useMotionValue(0)
         *   const opacity = useMotionValue(1)
         *
         *   useEffect(() => {
         *     function updateOpacity() {
         *       const maxXY = Math.max(x.get(), y.get())
         *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
         *       opacity.set(newOpacity)
         *     }
         *
         *     const unsubscribeX = x.on("change", updateOpacity)
         *     const unsubscribeY = y.on("change", updateOpacity)
         *
         *     return () => {
         *       unsubscribeX()
         *       unsubscribeY()
         *     }
         *   }, [])
         *
         *   return <motion.div style={{ x }} />
         * }
         * ```
         *
         * @param subscriber - A function that receives the latest value.
         * @returns A function that, when called, will cancel this subscription.
         *
         * @deprecated
         */
        onChange(subscription) {
          return this.on("change", subscription);
        }
        on(eventName, callback) {
          if (!this.events[eventName]) {
            this.events[eventName] = new SubscriptionManager();
          }
          const unsubscribe = this.events[eventName].add(callback);
          if (eventName === "change") {
            return () => {
              unsubscribe();
              frame.read(() => {
                if (!this.events.change.getSize()) {
                  this.stop();
                }
              });
            };
          }
          return unsubscribe;
        }
        clearListeners() {
          for (const eventManagers in this.events) {
            this.events[eventManagers].clear();
          }
        }
        /**
         * Attaches a passive effect to the `MotionValue`.
         */
        attach(passiveEffect, stopPassiveEffect) {
          this.passiveEffect = passiveEffect;
          this.stopPassiveEffect = stopPassiveEffect;
        }
        /**
         * Sets the state of the `MotionValue`.
         *
         * @remarks
         *
         * ```jsx
         * const x = useMotionValue(0)
         * x.set(10)
         * ```
         *
         * @param latest - Latest value to set.
         * @param render - Whether to notify render subscribers. Defaults to `true`
         *
         * @public
         */
        set(v) {
          if (!this.passiveEffect) {
            this.updateAndNotify(v);
          } else {
            this.passiveEffect(v, this.updateAndNotify);
          }
        }
        setWithVelocity(prev, current, delta) {
          this.set(current);
          this.prev = void 0;
          this.prevFrameValue = prev;
          this.prevUpdatedAt = this.updatedAt - delta;
        }
        /**
         * Set the state of the `MotionValue`, stopping any active animations,
         * effects, and resets velocity to `0`.
         */
        jump(v, endAnimation = true) {
          this.updateAndNotify(v);
          this.prev = v;
          this.prevUpdatedAt = this.prevFrameValue = void 0;
          endAnimation && this.stop();
          if (this.stopPassiveEffect)
            this.stopPassiveEffect();
        }
        dirty() {
          var _a;
          (_a = this.events.change) == null ? void 0 : _a.notify(this.current);
        }
        addDependent(dependent) {
          if (!this.dependents) {
            this.dependents = /* @__PURE__ */ new Set();
          }
          this.dependents.add(dependent);
        }
        removeDependent(dependent) {
          if (this.dependents) {
            this.dependents.delete(dependent);
          }
        }
        /**
         * Returns the latest state of `MotionValue`
         *
         * @returns - The latest state of `MotionValue`
         *
         * @public
         */
        get() {
          if (collectMotionValues.current) {
            collectMotionValues.current.push(this);
          }
          return this.current;
        }
        /**
         * @public
         */
        getPrevious() {
          return this.prev;
        }
        /**
         * Returns the latest velocity of `MotionValue`
         *
         * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
         *
         * @public
         */
        getVelocity() {
          const currentTime = time.now();
          if (!this.canTrackVelocity || this.prevFrameValue === void 0 || currentTime - this.updatedAt > MAX_VELOCITY_DELTA) {
            return 0;
          }
          const delta = Math.min(this.updatedAt - this.prevUpdatedAt, MAX_VELOCITY_DELTA);
          return velocityPerSecond(parseFloat(this.current) - parseFloat(this.prevFrameValue), delta);
        }
        /**
         * Registers a new animation to control this `MotionValue`. Only one
         * animation can drive a `MotionValue` at one time.
         *
         * ```jsx
         * value.start()
         * ```
         *
         * @param animation - A function that starts the provided animation
         */
        start(startAnimation) {
          this.stop();
          return new Promise((resolve) => {
            this.hasAnimated = true;
            this.animation = startAnimation(resolve);
            if (this.events.animationStart) {
              this.events.animationStart.notify();
            }
          }).then(() => {
            if (this.events.animationComplete) {
              this.events.animationComplete.notify();
            }
            this.clearAnimation();
          });
        }
        /**
         * Stop the currently active animation.
         *
         * @public
         */
        stop() {
          if (this.animation) {
            this.animation.stop();
            if (this.events.animationCancel) {
              this.events.animationCancel.notify();
            }
          }
          this.clearAnimation();
        }
        /**
         * Returns `true` if this value is currently animating.
         *
         * @public
         */
        isAnimating() {
          return !!this.animation;
        }
        clearAnimation() {
          delete this.animation;
        }
        /**
         * Destroy and clean up subscribers to this `MotionValue`.
         *
         * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
         * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
         * created a `MotionValue` via the `motionValue` function.
         *
         * @public
         */
        destroy() {
          var _a, _b;
          (_a = this.dependents) == null ? void 0 : _a.clear();
          (_b = this.events.destroy) == null ? void 0 : _b.notify();
          this.clearListeners();
          this.stop();
          if (this.stopPassiveEffect) {
            this.stopPassiveEffect();
          }
        }
      }
      exports("M", MotionValue);
      function motionValue(init, options) {
        return new MotionValue(init, options);
      }
      const { schedule: microtask, cancel: cancelMicrotask } = /* @__PURE__ */ createRenderBatcher(queueMicrotask, false);
      exports({ q: microtask, Y: cancelMicrotask });
      function isSVGSVGElement(element) {
        return isSVGElement(element) && element.tagName === "svg";
      }
      const isMotionValue = exports("j", (value) => Boolean(value && value.getVelocity));
      const valueTypes = [...dimensionValueTypes, color, complex];
      const findValueType = exports("ab", (v) => valueTypes.find(testValueType(v)));
      function isDOMKeyframes(keyframes2) {
        return typeof keyframes2 === "object" && !Array.isArray(keyframes2);
      }
      function resolveSubjects(subject, keyframes2, scope, selectorCache) {
        if (typeof subject === "string" && isDOMKeyframes(keyframes2)) {
          return resolveElements(subject, scope, selectorCache);
        } else if (subject instanceof NodeList) {
          return Array.from(subject);
        } else if (Array.isArray(subject)) {
          return subject;
        } else {
          return [subject];
        }
      }
      function calculateRepeatDuration(duration, repeat, _repeatDelay) {
        return duration * (repeat + 1);
      }
      function calcNextTime(current, next, prev, labels) {
        if (typeof next === "number") {
          return next;
        } else if (next.startsWith("-") || next.startsWith("+")) {
          return Math.max(0, current + parseFloat(next));
        } else if (next === "<") {
          return prev;
        } else if (next.startsWith("<")) {
          return Math.max(0, prev + parseFloat(next.slice(1)));
        } else {
          return labels.get(next) ?? current;
        }
      }
      function eraseKeyframes(sequence, startTime, endTime) {
        for (let i = 0; i < sequence.length; i++) {
          const keyframe = sequence[i];
          if (keyframe.at > startTime && keyframe.at < endTime) {
            removeItem(sequence, keyframe);
            i--;
          }
        }
      }
      function addKeyframes(sequence, keyframes2, easing, offset, startTime, endTime) {
        eraseKeyframes(sequence, startTime, endTime);
        for (let i = 0; i < keyframes2.length; i++) {
          sequence.push({
            value: keyframes2[i],
            at: mixNumber(startTime, endTime, offset[i]),
            easing: getEasingForSegment(easing, i)
          });
        }
      }
      function normalizeTimes(times, repeat) {
        for (let i = 0; i < times.length; i++) {
          times[i] = times[i] / (repeat + 1);
        }
      }
      function compareByTime(a, b) {
        if (a.at === b.at) {
          if (a.value === null)
            return 1;
          if (b.value === null)
            return -1;
          return 0;
        } else {
          return a.at - b.at;
        }
      }
      const defaultSegmentEasing = "easeInOut";
      function createAnimationsFromSequence(sequence, { defaultTransition = {}, ...sequenceTransition } = {}, scope, generators) {
        const defaultDuration = defaultTransition.duration || 0.3;
        const animationDefinitions = /* @__PURE__ */ new Map();
        const sequences = /* @__PURE__ */ new Map();
        const elementCache = {};
        const timeLabels = /* @__PURE__ */ new Map();
        let prevTime = 0;
        let currentTime = 0;
        let totalDuration = 0;
        for (let i = 0; i < sequence.length; i++) {
          const segment = sequence[i];
          if (typeof segment === "string") {
            timeLabels.set(segment, currentTime);
            continue;
          } else if (!Array.isArray(segment)) {
            timeLabels.set(segment.name, calcNextTime(currentTime, segment.at, prevTime, timeLabels));
            continue;
          }
          let [subject, keyframes2, transition = {}] = segment;
          if (transition.at !== void 0) {
            currentTime = calcNextTime(currentTime, transition.at, prevTime, timeLabels);
          }
          let maxDuration = 0;
          const resolveValueSequence = (valueKeyframes, valueTransition, valueSequence, elementIndex = 0, numSubjects = 0) => {
            const valueKeyframesAsList = keyframesAsList(valueKeyframes);
            const { delay = 0, times = defaultOffset(valueKeyframesAsList), type = "keyframes", repeat, repeatType, repeatDelay = 0, ...remainingTransition } = valueTransition;
            let { ease: ease2 = defaultTransition.ease || "easeOut", duration } = valueTransition;
            const calculatedDelay = typeof delay === "function" ? delay(elementIndex, numSubjects) : delay;
            const numKeyframes = valueKeyframesAsList.length;
            const createGenerator = isGenerator(type) ? type : generators == null ? void 0 : generators[type || "keyframes"];
            if (numKeyframes <= 2 && createGenerator) {
              let absoluteDelta = 100;
              if (numKeyframes === 2 && isNumberKeyframesArray(valueKeyframesAsList)) {
                const delta = valueKeyframesAsList[1] - valueKeyframesAsList[0];
                absoluteDelta = Math.abs(delta);
              }
              const springTransition = { ...remainingTransition };
              if (duration !== void 0) {
                springTransition.duration = secondsToMilliseconds(duration);
              }
              const springEasing = createGeneratorEasing(springTransition, absoluteDelta, createGenerator);
              ease2 = springEasing.ease;
              duration = springEasing.duration;
            }
            duration ?? (duration = defaultDuration);
            const startTime = currentTime + calculatedDelay;
            if (times.length === 1 && times[0] === 0) {
              times[1] = 1;
            }
            const remainder = times.length - valueKeyframesAsList.length;
            remainder > 0 && fillOffset(times, remainder);
            valueKeyframesAsList.length === 1 && valueKeyframesAsList.unshift(null);
            if (repeat) {
              duration = calculateRepeatDuration(duration, repeat);
              const originalKeyframes = [...valueKeyframesAsList];
              const originalTimes = [...times];
              ease2 = Array.isArray(ease2) ? [...ease2] : [ease2];
              const originalEase = [...ease2];
              for (let repeatIndex = 0; repeatIndex < repeat; repeatIndex++) {
                valueKeyframesAsList.push(...originalKeyframes);
                for (let keyframeIndex = 0; keyframeIndex < originalKeyframes.length; keyframeIndex++) {
                  times.push(originalTimes[keyframeIndex] + (repeatIndex + 1));
                  ease2.push(keyframeIndex === 0 ? "linear" : getEasingForSegment(originalEase, keyframeIndex - 1));
                }
              }
              normalizeTimes(times, repeat);
            }
            const targetTime = startTime + duration;
            addKeyframes(valueSequence, valueKeyframesAsList, ease2, times, startTime, targetTime);
            maxDuration = Math.max(calculatedDelay + duration, maxDuration);
            totalDuration = Math.max(targetTime, totalDuration);
          };
          if (isMotionValue(subject)) {
            const subjectSequence = getSubjectSequence(subject, sequences);
            resolveValueSequence(keyframes2, transition, getValueSequence("default", subjectSequence));
          } else {
            const subjects = resolveSubjects(subject, keyframes2, scope, elementCache);
            const numSubjects = subjects.length;
            for (let subjectIndex = 0; subjectIndex < numSubjects; subjectIndex++) {
              keyframes2 = keyframes2;
              transition = transition;
              const thisSubject = subjects[subjectIndex];
              const subjectSequence = getSubjectSequence(thisSubject, sequences);
              for (const key in keyframes2) {
                resolveValueSequence(keyframes2[key], getValueTransition(transition, key), getValueSequence(key, subjectSequence), subjectIndex, numSubjects);
              }
            }
          }
          prevTime = currentTime;
          currentTime += maxDuration;
        }
        sequences.forEach((valueSequences, element) => {
          for (const key in valueSequences) {
            const valueSequence = valueSequences[key];
            valueSequence.sort(compareByTime);
            const keyframes2 = [];
            const valueOffset = [];
            const valueEasing = [];
            for (let i = 0; i < valueSequence.length; i++) {
              const { at, value, easing } = valueSequence[i];
              keyframes2.push(value);
              valueOffset.push(progress(0, totalDuration, at));
              valueEasing.push(easing || "easeOut");
            }
            if (valueOffset[0] !== 0) {
              valueOffset.unshift(0);
              keyframes2.unshift(keyframes2[0]);
              valueEasing.unshift(defaultSegmentEasing);
            }
            if (valueOffset[valueOffset.length - 1] !== 1) {
              valueOffset.push(1);
              keyframes2.push(null);
            }
            if (!animationDefinitions.has(element)) {
              animationDefinitions.set(element, {
                keyframes: {},
                transition: {}
              });
            }
            const definition = animationDefinitions.get(element);
            definition.keyframes[key] = keyframes2;
            definition.transition[key] = {
              ...defaultTransition,
              duration: totalDuration,
              ease: valueEasing,
              times: valueOffset,
              ...sequenceTransition
            };
          }
        });
        return animationDefinitions;
      }
      function getSubjectSequence(subject, sequences) {
        !sequences.has(subject) && sequences.set(subject, {});
        return sequences.get(subject);
      }
      function getValueSequence(name, sequences) {
        if (!sequences[name])
          sequences[name] = [];
        return sequences[name];
      }
      function keyframesAsList(keyframes2) {
        return Array.isArray(keyframes2) ? keyframes2 : [keyframes2];
      }
      function getValueTransition(transition, key) {
        return transition && transition[key] ? {
          ...transition,
          ...transition[key]
        } : { ...transition };
      }
      const isNumber = (keyframe) => typeof keyframe === "number";
      const isNumberKeyframesArray = (keyframes2) => keyframes2.every(isNumber);
      const visualElementStore = /* @__PURE__ */ new WeakMap();
      const isKeyframesTarget = (v) => {
        return Array.isArray(v);
      };
      function getValueState(visualElement) {
        const state = [{}, {}];
        visualElement == null ? void 0 : visualElement.values.forEach((value, key) => {
          state[0][key] = value.get();
          state[1][key] = value.getVelocity();
        });
        return state;
      }
      function resolveVariantFromProps(props, definition, custom, visualElement) {
        if (typeof definition === "function") {
          const [current, velocity] = getValueState(visualElement);
          definition = definition(custom !== void 0 ? custom : props.custom, current, velocity);
        }
        if (typeof definition === "string") {
          definition = props.variants && props.variants[definition];
        }
        if (typeof definition === "function") {
          const [current, velocity] = getValueState(visualElement);
          definition = definition(custom !== void 0 ? custom : props.custom, current, velocity);
        }
        return definition;
      }
      function resolveVariant(visualElement, definition, custom) {
        const props = visualElement.getProps();
        return resolveVariantFromProps(props, definition, props.custom, visualElement);
      }
      function setMotionValue(visualElement, key, value) {
        if (visualElement.hasValue(key)) {
          visualElement.getValue(key).set(value);
        } else {
          visualElement.addValue(key, motionValue(value));
        }
      }
      function resolveFinalValueInKeyframes(v) {
        return isKeyframesTarget(v) ? v[v.length - 1] || 0 : v;
      }
      function setTarget(visualElement, definition) {
        const resolved = resolveVariant(visualElement, definition);
        let { transitionEnd = {}, transition = {}, ...target } = resolved || {};
        target = { ...target, ...transitionEnd };
        for (const key in target) {
          const value = resolveFinalValueInKeyframes(target[key]);
          setMotionValue(visualElement, key, value);
        }
      }
      function isWillChangeMotionValue(value) {
        return Boolean(isMotionValue(value) && value.add);
      }
      function addValueToWillChange(visualElement, key) {
        const willChange = visualElement.getValue("willChange");
        if (isWillChangeMotionValue(willChange)) {
          return willChange.add(key);
        } else if (!willChange && MotionGlobalConfig.WillChange) {
          const newWillChange = new MotionGlobalConfig.WillChange("auto");
          visualElement.addValue("willChange", newWillChange);
          newWillChange.add(key);
        }
      }
      const camelToDash = (str) => str.replace(/([a-z])([A-Z])/gu, "$1-$2").toLowerCase();
      const optimizedAppearDataId = "framerAppearId";
      const optimizedAppearDataAttribute = "data-" + camelToDash(optimizedAppearDataId);
      function getOptimisedAppearId(visualElement) {
        return visualElement.props[optimizedAppearDataAttribute];
      }
      const isNotNull = (value) => value !== null;
      function getFinalKeyframe(keyframes2, { repeat, repeatType = "loop" }, finalKeyframe) {
        const resolvedKeyframes = keyframes2.filter(isNotNull);
        const index = repeat && repeatType !== "loop" && repeat % 2 === 1 ? 0 : resolvedKeyframes.length - 1;
        return resolvedKeyframes[index];
      }
      const underDampedSpring = {
        type: "spring",
        stiffness: 500,
        damping: 25,
        restSpeed: 10
      };
      const criticallyDampedSpring = (target) => ({
        type: "spring",
        stiffness: 550,
        damping: target === 0 ? 2 * Math.sqrt(550) : 30,
        restSpeed: 10
      });
      const keyframesTransition = {
        type: "keyframes",
        duration: 0.8
      };
      const ease = {
        type: "keyframes",
        ease: [0.25, 0.1, 0.35, 1],
        duration: 0.3
      };
      const getDefaultTransition = (valueKey, { keyframes: keyframes2 }) => {
        if (keyframes2.length > 2) {
          return keyframesTransition;
        } else if (transformProps.has(valueKey)) {
          return valueKey.startsWith("scale") ? criticallyDampedSpring(keyframes2[1]) : underDampedSpring;
        }
        return ease;
      };
      function isTransitionDefined({ when, delay: _delay, delayChildren, staggerChildren, staggerDirection, repeat, repeatType, repeatDelay, from, elapsed, ...transition }) {
        return !!Object.keys(transition).length;
      }
      const animateMotionValue = (name, value, target, transition = {}, element, isHandoff) => (onComplete) => {
        const valueTransition = getValueTransition$1(transition, name) || {};
        const delay = valueTransition.delay || transition.delay || 0;
        let { elapsed = 0 } = transition;
        elapsed = elapsed - secondsToMilliseconds(delay);
        const options = {
          keyframes: Array.isArray(target) ? target : [null, target],
          ease: "easeOut",
          velocity: value.getVelocity(),
          ...valueTransition,
          delay: -elapsed,
          onUpdate: (v) => {
            value.set(v);
            valueTransition.onUpdate && valueTransition.onUpdate(v);
          },
          onComplete: () => {
            onComplete();
            valueTransition.onComplete && valueTransition.onComplete();
          },
          name,
          motionValue: value,
          element: isHandoff ? void 0 : element
        };
        if (!isTransitionDefined(valueTransition)) {
          Object.assign(options, getDefaultTransition(name, options));
        }
        options.duration && (options.duration = secondsToMilliseconds(options.duration));
        options.repeatDelay && (options.repeatDelay = secondsToMilliseconds(options.repeatDelay));
        if (options.from !== void 0) {
          options.keyframes[0] = options.from;
        }
        let shouldSkip = false;
        if (options.type === false || options.duration === 0 && !options.repeatDelay) {
          makeAnimationInstant(options);
          if (options.delay === 0) {
            shouldSkip = true;
          }
        }
        if (MotionGlobalConfig.instantAnimations || MotionGlobalConfig.skipAnimations) {
          shouldSkip = true;
          makeAnimationInstant(options);
          options.delay = 0;
        }
        options.allowFlatten = !valueTransition.type && !valueTransition.ease;
        if (shouldSkip && !isHandoff && value.get() !== void 0) {
          const finalKeyframe = getFinalKeyframe(options.keyframes, valueTransition);
          if (finalKeyframe !== void 0) {
            frame.update(() => {
              options.onUpdate(finalKeyframe);
              options.onComplete();
            });
            return;
          }
        }
        return valueTransition.isSync ? new JSAnimation(options) : new AsyncMotionValueAnimation(options);
      };
      function shouldBlockAnimation({ protectedKeys, needsAnimating }, key) {
        const shouldBlock = protectedKeys.hasOwnProperty(key) && needsAnimating[key] !== true;
        needsAnimating[key] = false;
        return shouldBlock;
      }
      function animateTarget(visualElement, targetAndTransition, { delay = 0, transitionOverride, type } = {}) {
        let { transition = visualElement.getDefaultTransition(), transitionEnd, ...target } = targetAndTransition;
        if (transitionOverride)
          transition = transitionOverride;
        const animations = [];
        const animationTypeState = type && visualElement.animationState && visualElement.animationState.getState()[type];
        for (const key in target) {
          const value = visualElement.getValue(key, visualElement.latestValues[key] ?? null);
          const valueTarget = target[key];
          if (valueTarget === void 0 || animationTypeState && shouldBlockAnimation(animationTypeState, key)) {
            continue;
          }
          const valueTransition = {
            delay,
            ...getValueTransition$1(transition || {}, key)
          };
          const currentValue = value.get();
          if (currentValue !== void 0 && !value.isAnimating && !Array.isArray(valueTarget) && valueTarget === currentValue && !valueTransition.velocity) {
            continue;
          }
          let isHandoff = false;
          if (window.MotionHandoffAnimation) {
            const appearId = getOptimisedAppearId(visualElement);
            if (appearId) {
              const startTime = window.MotionHandoffAnimation(appearId, key, frame);
              if (startTime !== null) {
                valueTransition.startTime = startTime;
                isHandoff = true;
              }
            }
          }
          addValueToWillChange(visualElement, key);
          value.start(animateMotionValue(key, value, valueTarget, visualElement.shouldReduceMotion && positionalKeys.has(key) ? { type: false } : valueTransition, visualElement, isHandoff));
          const animation = value.animation;
          if (animation) {
            animations.push(animation);
          }
        }
        if (transitionEnd) {
          Promise.all(animations).then(() => {
            frame.update(() => {
              transitionEnd && setTarget(visualElement, transitionEnd);
            });
          });
        }
        return animations;
      }
      function convertBoundingBoxToBox({ top, left, right, bottom }) {
        return {
          x: { min: left, max: right },
          y: { min: top, max: bottom }
        };
      }
      function transformBoxPoints(point, transformPoint) {
        if (!transformPoint)
          return point;
        const topLeft = transformPoint({ x: point.left, y: point.top });
        const bottomRight = transformPoint({ x: point.right, y: point.bottom });
        return {
          top: topLeft.y,
          left: topLeft.x,
          bottom: bottomRight.y,
          right: bottomRight.x
        };
      }
      function measureViewportBox(instance, transformPoint) {
        return convertBoundingBoxToBox(transformBoxPoints(instance.getBoundingClientRect(), transformPoint));
      }
      const featureProps = {
        animation: [
          "animate",
          "variants",
          "whileHover",
          "whileTap",
          "exit",
          "whileInView",
          "whileFocus",
          "whileDrag"
        ],
        exit: ["exit"],
        drag: ["drag", "dragControls"],
        focus: ["whileFocus"],
        hover: ["whileHover", "onHoverStart", "onHoverEnd"],
        tap: ["whileTap", "onTap", "onTapStart", "onTapCancel"],
        pan: ["onPan", "onPanStart", "onPanSessionStart", "onPanEnd"],
        inView: ["whileInView", "onViewportEnter", "onViewportLeave"],
        layout: ["layout", "layoutId"]
      };
      const featureDefinitions = {};
      for (const key in featureProps) {
        featureDefinitions[key] = {
          isEnabled: (props) => featureProps[key].some((name) => !!props[name])
        };
      }
      const createAxis = () => ({ min: 0, max: 0 });
      const createBox = () => ({
        x: createAxis(),
        y: createAxis()
      });
      const isBrowser = typeof window !== "undefined";
      const prefersReducedMotion = { current: null };
      const hasReducedMotionListener = { current: false };
      function initPrefersReducedMotion() {
        hasReducedMotionListener.current = true;
        if (!isBrowser)
          return;
        if (window.matchMedia) {
          const motionMediaQuery = window.matchMedia("(prefers-reduced-motion)");
          const setReducedMotionPreferences = () => prefersReducedMotion.current = motionMediaQuery.matches;
          motionMediaQuery.addEventListener("change", setReducedMotionPreferences);
          setReducedMotionPreferences();
        } else {
          prefersReducedMotion.current = false;
        }
      }
      function isAnimationControls(v) {
        return v !== null && typeof v === "object" && typeof v.start === "function";
      }
      function isVariantLabel(v) {
        return typeof v === "string" || Array.isArray(v);
      }
      const variantPriorityOrder = [
        "animate",
        "whileInView",
        "whileFocus",
        "whileHover",
        "whileTap",
        "whileDrag",
        "exit"
      ];
      const variantProps = ["initial", ...variantPriorityOrder];
      function isControllingVariants(props) {
        return isAnimationControls(props.animate) || variantProps.some((name) => isVariantLabel(props[name]));
      }
      function isVariantNode(props) {
        return Boolean(isControllingVariants(props) || props.variants);
      }
      function updateMotionValuesFromProps(element, next, prev) {
        for (const key in next) {
          const nextValue = next[key];
          const prevValue = prev[key];
          if (isMotionValue(nextValue)) {
            element.addValue(key, nextValue);
          } else if (isMotionValue(prevValue)) {
            element.addValue(key, motionValue(nextValue, { owner: element }));
          } else if (prevValue !== nextValue) {
            if (element.hasValue(key)) {
              const existingValue = element.getValue(key);
              if (existingValue.liveStyle === true) {
                existingValue.jump(nextValue);
              } else if (!existingValue.hasAnimated) {
                existingValue.set(nextValue);
              }
            } else {
              const latestValue = element.getStaticValue(key);
              element.addValue(key, motionValue(latestValue !== void 0 ? latestValue : nextValue, { owner: element }));
            }
          }
        }
        for (const key in prev) {
          if (next[key] === void 0)
            element.removeValue(key);
        }
        return next;
      }
      const propEventHandlers = [
        "AnimationStart",
        "AnimationComplete",
        "Update",
        "BeforeLayoutMeasure",
        "LayoutMeasure",
        "LayoutAnimationStart",
        "LayoutAnimationComplete"
      ];
      class VisualElement {
        /**
         * This method takes React props and returns found MotionValues. For example, HTML
         * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
         *
         * This isn't an abstract method as it needs calling in the constructor, but it is
         * intended to be one.
         */
        scrapeMotionValuesFromProps(_props, _prevProps, _visualElement) {
          return {};
        }
        constructor({ parent, props, presenceContext, reducedMotionConfig, blockInitialAnimation, visualState }, options = {}) {
          this.current = null;
          this.children = /* @__PURE__ */ new Set();
          this.isVariantNode = false;
          this.isControllingVariants = false;
          this.shouldReduceMotion = null;
          this.values = /* @__PURE__ */ new Map();
          this.KeyframeResolver = KeyframeResolver;
          this.features = {};
          this.valueSubscriptions = /* @__PURE__ */ new Map();
          this.prevMotionValues = {};
          this.events = {};
          this.propEventSubscriptions = {};
          this.notifyUpdate = () => this.notify("Update", this.latestValues);
          this.render = () => {
            if (!this.current)
              return;
            this.triggerBuild();
            this.renderInstance(this.current, this.renderState, this.props.style, this.projection);
          };
          this.renderScheduledAt = 0;
          this.scheduleRender = () => {
            const now2 = time.now();
            if (this.renderScheduledAt < now2) {
              this.renderScheduledAt = now2;
              frame.render(this.render, false, true);
            }
          };
          const { latestValues, renderState } = visualState;
          this.latestValues = latestValues;
          this.baseTarget = { ...latestValues };
          this.initialValues = props.initial ? { ...latestValues } : {};
          this.renderState = renderState;
          this.parent = parent;
          this.props = props;
          this.presenceContext = presenceContext;
          this.depth = parent ? parent.depth + 1 : 0;
          this.reducedMotionConfig = reducedMotionConfig;
          this.options = options;
          this.blockInitialAnimation = Boolean(blockInitialAnimation);
          this.isControllingVariants = isControllingVariants(props);
          this.isVariantNode = isVariantNode(props);
          if (this.isVariantNode) {
            this.variantChildren = /* @__PURE__ */ new Set();
          }
          this.manuallyAnimateOnMount = Boolean(parent && parent.current);
          const { willChange, ...initialMotionValues } = this.scrapeMotionValuesFromProps(props, {}, this);
          for (const key in initialMotionValues) {
            const value = initialMotionValues[key];
            if (latestValues[key] !== void 0 && isMotionValue(value)) {
              value.set(latestValues[key]);
            }
          }
        }
        mount(instance) {
          var _a;
          this.current = instance;
          visualElementStore.set(instance, this);
          if (this.projection && !this.projection.instance) {
            this.projection.mount(instance);
          }
          if (this.parent && this.isVariantNode && !this.isControllingVariants) {
            this.removeFromVariantTree = this.parent.addVariantChild(this);
          }
          this.values.forEach((value, key) => this.bindToMotionValue(key, value));
          if (!hasReducedMotionListener.current) {
            initPrefersReducedMotion();
          }
          this.shouldReduceMotion = this.reducedMotionConfig === "never" ? false : this.reducedMotionConfig === "always" ? true : prefersReducedMotion.current;
          (_a = this.parent) == null ? void 0 : _a.addChild(this);
          this.update(this.props, this.presenceContext);
        }
        unmount() {
          var _a;
          this.projection && this.projection.unmount();
          cancelFrame(this.notifyUpdate);
          cancelFrame(this.render);
          this.valueSubscriptions.forEach((remove) => remove());
          this.valueSubscriptions.clear();
          this.removeFromVariantTree && this.removeFromVariantTree();
          (_a = this.parent) == null ? void 0 : _a.removeChild(this);
          for (const key in this.events) {
            this.events[key].clear();
          }
          for (const key in this.features) {
            const feature = this.features[key];
            if (feature) {
              feature.unmount();
              feature.isMounted = false;
            }
          }
          this.current = null;
        }
        addChild(child) {
          this.children.add(child);
          this.enteringChildren ?? (this.enteringChildren = /* @__PURE__ */ new Set());
          this.enteringChildren.add(child);
        }
        removeChild(child) {
          this.children.delete(child);
          this.enteringChildren && this.enteringChildren.delete(child);
        }
        bindToMotionValue(key, value) {
          if (this.valueSubscriptions.has(key)) {
            this.valueSubscriptions.get(key)();
          }
          const valueIsTransform = transformProps.has(key);
          if (valueIsTransform && this.onBindTransform) {
            this.onBindTransform();
          }
          const removeOnChange = value.on("change", (latestValue) => {
            this.latestValues[key] = latestValue;
            this.props.onUpdate && frame.preRender(this.notifyUpdate);
            if (valueIsTransform && this.projection) {
              this.projection.isTransformDirty = true;
            }
            this.scheduleRender();
          });
          let removeSyncCheck;
          if (window.MotionCheckAppearSync) {
            removeSyncCheck = window.MotionCheckAppearSync(this, key, value);
          }
          this.valueSubscriptions.set(key, () => {
            removeOnChange();
            if (removeSyncCheck)
              removeSyncCheck();
            if (value.owner)
              value.stop();
          });
        }
        sortNodePosition(other) {
          if (!this.current || !this.sortInstanceNodePosition || this.type !== other.type) {
            return 0;
          }
          return this.sortInstanceNodePosition(this.current, other.current);
        }
        updateFeatures() {
          let key = "animation";
          for (key in featureDefinitions) {
            const featureDefinition = featureDefinitions[key];
            if (!featureDefinition)
              continue;
            const { isEnabled, Feature: FeatureConstructor } = featureDefinition;
            if (!this.features[key] && FeatureConstructor && isEnabled(this.props)) {
              this.features[key] = new FeatureConstructor(this);
            }
            if (this.features[key]) {
              const feature = this.features[key];
              if (feature.isMounted) {
                feature.update();
              } else {
                feature.mount();
                feature.isMounted = true;
              }
            }
          }
        }
        triggerBuild() {
          this.build(this.renderState, this.latestValues, this.props);
        }
        /**
         * Measure the current viewport box with or without transforms.
         * Only measures axis-aligned boxes, rotate and skew must be manually
         * removed with a re-render to work.
         */
        measureViewportBox() {
          return this.current ? this.measureInstanceViewportBox(this.current, this.props) : createBox();
        }
        getStaticValue(key) {
          return this.latestValues[key];
        }
        setStaticValue(key, value) {
          this.latestValues[key] = value;
        }
        /**
         * Update the provided props. Ensure any newly-added motion values are
         * added to our map, old ones removed, and listeners updated.
         */
        update(props, presenceContext) {
          if (props.transformTemplate || this.props.transformTemplate) {
            this.scheduleRender();
          }
          this.prevProps = this.props;
          this.props = props;
          this.prevPresenceContext = this.presenceContext;
          this.presenceContext = presenceContext;
          for (let i = 0; i < propEventHandlers.length; i++) {
            const key = propEventHandlers[i];
            if (this.propEventSubscriptions[key]) {
              this.propEventSubscriptions[key]();
              delete this.propEventSubscriptions[key];
            }
            const listenerName = "on" + key;
            const listener = props[listenerName];
            if (listener) {
              this.propEventSubscriptions[key] = this.on(key, listener);
            }
          }
          this.prevMotionValues = updateMotionValuesFromProps(this, this.scrapeMotionValuesFromProps(props, this.prevProps, this), this.prevMotionValues);
          if (this.handleChildMotionValue) {
            this.handleChildMotionValue();
          }
        }
        getProps() {
          return this.props;
        }
        /**
         * Returns the variant definition with a given name.
         */
        getVariant(name) {
          return this.props.variants ? this.props.variants[name] : void 0;
        }
        /**
         * Returns the defined default transition on this component.
         */
        getDefaultTransition() {
          return this.props.transition;
        }
        getTransformPagePoint() {
          return this.props.transformPagePoint;
        }
        getClosestVariantNode() {
          return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : void 0;
        }
        /**
         * Add a child visual element to our set of children.
         */
        addVariantChild(child) {
          const closestVariantNode = this.getClosestVariantNode();
          if (closestVariantNode) {
            closestVariantNode.variantChildren && closestVariantNode.variantChildren.add(child);
            return () => closestVariantNode.variantChildren.delete(child);
          }
        }
        /**
         * Add a motion value and bind it to this visual element.
         */
        addValue(key, value) {
          const existingValue = this.values.get(key);
          if (value !== existingValue) {
            if (existingValue)
              this.removeValue(key);
            this.bindToMotionValue(key, value);
            this.values.set(key, value);
            this.latestValues[key] = value.get();
          }
        }
        /**
         * Remove a motion value and unbind any active subscriptions.
         */
        removeValue(key) {
          this.values.delete(key);
          const unsubscribe = this.valueSubscriptions.get(key);
          if (unsubscribe) {
            unsubscribe();
            this.valueSubscriptions.delete(key);
          }
          delete this.latestValues[key];
          this.removeValueFromRenderState(key, this.renderState);
        }
        /**
         * Check whether we have a motion value for this key
         */
        hasValue(key) {
          return this.values.has(key);
        }
        getValue(key, defaultValue) {
          if (this.props.values && this.props.values[key]) {
            return this.props.values[key];
          }
          let value = this.values.get(key);
          if (value === void 0 && defaultValue !== void 0) {
            value = motionValue(defaultValue === null ? void 0 : defaultValue, { owner: this });
            this.addValue(key, value);
          }
          return value;
        }
        /**
         * If we're trying to animate to a previously unencountered value,
         * we need to check for it in our state and as a last resort read it
         * directly from the instance (which might have performance implications).
         */
        readValue(key, target) {
          let value = this.latestValues[key] !== void 0 || !this.current ? this.latestValues[key] : this.getBaseTargetFromProps(this.props, key) ?? this.readValueFromInstance(this.current, key, this.options);
          if (value !== void 0 && value !== null) {
            if (typeof value === "string" && (isNumericalString(value) || isZeroValueString(value))) {
              value = parseFloat(value);
            } else if (!findValueType(value) && complex.test(target)) {
              value = getAnimatableNone(key, target);
            }
            this.setBaseTarget(key, isMotionValue(value) ? value.get() : value);
          }
          return isMotionValue(value) ? value.get() : value;
        }
        /**
         * Set the base target to later animate back to. This is currently
         * only hydrated on creation and when we first read a value.
         */
        setBaseTarget(key, value) {
          this.baseTarget[key] = value;
        }
        /**
         * Find the base target for a value thats been removed from all animation
         * props.
         */
        getBaseTarget(key) {
          var _a;
          const { initial } = this.props;
          let valueFromInitial;
          if (typeof initial === "string" || typeof initial === "object") {
            const variant = resolveVariantFromProps(this.props, initial, (_a = this.presenceContext) == null ? void 0 : _a.custom);
            if (variant) {
              valueFromInitial = variant[key];
            }
          }
          if (initial && valueFromInitial !== void 0) {
            return valueFromInitial;
          }
          const target = this.getBaseTargetFromProps(this.props, key);
          if (target !== void 0 && !isMotionValue(target))
            return target;
          return this.initialValues[key] !== void 0 && valueFromInitial === void 0 ? void 0 : this.baseTarget[key];
        }
        on(eventName, callback) {
          if (!this.events[eventName]) {
            this.events[eventName] = new SubscriptionManager();
          }
          return this.events[eventName].add(callback);
        }
        notify(eventName, ...args) {
          if (this.events[eventName]) {
            this.events[eventName].notify(...args);
          }
        }
        scheduleRenderMicrotask() {
          microtask.render(this.render);
        }
      }
      class DOMVisualElement extends VisualElement {
        constructor() {
          super(...arguments);
          this.KeyframeResolver = DOMKeyframesResolver;
        }
        sortInstanceNodePosition(a, b) {
          return a.compareDocumentPosition(b) & 2 ? 1 : -1;
        }
        getBaseTargetFromProps(props, key) {
          return props.style ? props.style[key] : void 0;
        }
        removeValueFromRenderState(key, { vars, style }) {
          delete vars[key];
          delete style[key];
        }
        handleChildMotionValue() {
          if (this.childSubscription) {
            this.childSubscription();
            delete this.childSubscription;
          }
          const { children } = this.props;
          if (isMotionValue(children)) {
            this.childSubscription = children.on("change", (latest) => {
              if (this.current) {
                this.current.textContent = `${latest}`;
              }
            });
          }
        }
      }
      const translateAlias = {
        x: "translateX",
        y: "translateY",
        z: "translateZ",
        transformPerspective: "perspective"
      };
      const numTransforms = transformPropOrder.length;
      function buildTransform(latestValues, transform, transformTemplate) {
        let transformString = "";
        let transformIsDefault = true;
        for (let i = 0; i < numTransforms; i++) {
          const key = transformPropOrder[i];
          const value = latestValues[key];
          if (value === void 0)
            continue;
          let valueIsDefault = true;
          if (typeof value === "number") {
            valueIsDefault = value === (key.startsWith("scale") ? 1 : 0);
          } else {
            valueIsDefault = parseFloat(value) === 0;
          }
          if (!valueIsDefault || transformTemplate) {
            const valueAsType = getValueAsType(value, numberValueTypes[key]);
            if (!valueIsDefault) {
              transformIsDefault = false;
              const transformName = translateAlias[key] || key;
              transformString += `${transformName}(${valueAsType}) `;
            }
            if (transformTemplate) {
              transform[key] = valueAsType;
            }
          }
        }
        transformString = transformString.trim();
        if (transformTemplate) {
          transformString = transformTemplate(transform, transformIsDefault ? "" : transformString);
        } else if (transformIsDefault) {
          transformString = "none";
        }
        return transformString;
      }
      function buildHTMLStyles(state, latestValues, transformTemplate) {
        const { style, vars, transformOrigin } = state;
        let hasTransform = false;
        let hasTransformOrigin = false;
        for (const key in latestValues) {
          const value = latestValues[key];
          if (transformProps.has(key)) {
            hasTransform = true;
            continue;
          } else if (isCSSVariableName(key)) {
            vars[key] = value;
            continue;
          } else {
            const valueAsType = getValueAsType(value, numberValueTypes[key]);
            if (key.startsWith("origin")) {
              hasTransformOrigin = true;
              transformOrigin[key] = valueAsType;
            } else {
              style[key] = valueAsType;
            }
          }
        }
        if (!latestValues.transform) {
          if (hasTransform || transformTemplate) {
            style.transform = buildTransform(latestValues, state.transform, transformTemplate);
          } else if (style.transform) {
            style.transform = "none";
          }
        }
        if (hasTransformOrigin) {
          const { originX = "50%", originY = "50%", originZ = 0 } = transformOrigin;
          style.transformOrigin = `${originX} ${originY} ${originZ}`;
        }
      }
      function renderHTML(element, { style, vars }, styleProp, projection) {
        const elementStyle = element.style;
        let key;
        for (key in style) {
          elementStyle[key] = style[key];
        }
        projection == null ? void 0 : projection.applyProjectionStyles(elementStyle, styleProp);
        for (key in vars) {
          elementStyle.setProperty(key, vars[key]);
        }
      }
      const scaleCorrectors = {};
      function isForcedMotionValue(key, { layout, layoutId }) {
        return transformProps.has(key) || key.startsWith("origin") || (layout || layoutId !== void 0) && (!!scaleCorrectors[key] || key === "opacity");
      }
      function scrapeMotionValuesFromProps$1(props, prevProps, visualElement) {
        var _a;
        const { style } = props;
        const newValues = {};
        for (const key in style) {
          if (isMotionValue(style[key]) || prevProps.style && isMotionValue(prevProps.style[key]) || isForcedMotionValue(key, props) || ((_a = visualElement == null ? void 0 : visualElement.getValue(key)) == null ? void 0 : _a.liveStyle) !== void 0) {
            newValues[key] = style[key];
          }
        }
        return newValues;
      }
      function getComputedStyle$1(element) {
        return window.getComputedStyle(element);
      }
      class HTMLVisualElement extends DOMVisualElement {
        constructor() {
          super(...arguments);
          this.type = "html";
          this.renderInstance = renderHTML;
        }
        readValueFromInstance(instance, key) {
          var _a;
          if (transformProps.has(key)) {
            return ((_a = this.projection) == null ? void 0 : _a.isProjecting) ? defaultTransformValue(key) : readTransformValue(instance, key);
          } else {
            const computedStyle = getComputedStyle$1(instance);
            const value = (isCSSVariableName(key) ? computedStyle.getPropertyValue(key) : computedStyle[key]) || 0;
            return typeof value === "string" ? value.trim() : value;
          }
        }
        measureInstanceViewportBox(instance, { transformPagePoint }) {
          return measureViewportBox(instance, transformPagePoint);
        }
        build(renderState, latestValues, props) {
          buildHTMLStyles(renderState, latestValues, props.transformTemplate);
        }
        scrapeMotionValuesFromProps(props, prevProps, visualElement) {
          return scrapeMotionValuesFromProps$1(props, prevProps, visualElement);
        }
      }
      function isObjectKey(key, object) {
        return key in object;
      }
      class ObjectVisualElement extends VisualElement {
        constructor() {
          super(...arguments);
          this.type = "object";
        }
        readValueFromInstance(instance, key) {
          if (isObjectKey(key, instance)) {
            const value = instance[key];
            if (typeof value === "string" || typeof value === "number") {
              return value;
            }
          }
          return void 0;
        }
        getBaseTargetFromProps() {
          return void 0;
        }
        removeValueFromRenderState(key, renderState) {
          delete renderState.output[key];
        }
        measureInstanceViewportBox() {
          return createBox();
        }
        build(renderState, latestValues) {
          Object.assign(renderState.output, latestValues);
        }
        renderInstance(instance, { output }) {
          Object.assign(instance, output);
        }
        sortInstanceNodePosition() {
          return 0;
        }
      }
      const dashKeys = {
        offset: "stroke-dashoffset",
        array: "stroke-dasharray"
      };
      const camelKeys = {
        offset: "strokeDashoffset",
        array: "strokeDasharray"
      };
      function buildSVGPath(attrs, length, spacing = 1, offset = 0, useDashCase = true) {
        attrs.pathLength = 1;
        const keys = useDashCase ? dashKeys : camelKeys;
        attrs[keys.offset] = px.transform(-offset);
        const pathLength = px.transform(length);
        const pathSpacing = px.transform(spacing);
        attrs[keys.array] = `${pathLength} ${pathSpacing}`;
      }
      function buildSVGAttrs(state, {
        attrX,
        attrY,
        attrScale,
        pathLength,
        pathSpacing = 1,
        pathOffset = 0,
        // This is object creation, which we try to avoid per-frame.
        ...latest
      }, isSVGTag2, transformTemplate, styleProp) {
        buildHTMLStyles(state, latest, transformTemplate);
        if (isSVGTag2) {
          if (state.style.viewBox) {
            state.attrs.viewBox = state.style.viewBox;
          }
          return;
        }
        state.attrs = state.style;
        state.style = {};
        const { attrs, style } = state;
        if (attrs.transform) {
          style.transform = attrs.transform;
          delete attrs.transform;
        }
        if (style.transform || attrs.transformOrigin) {
          style.transformOrigin = attrs.transformOrigin ?? "50% 50%";
          delete attrs.transformOrigin;
        }
        if (style.transform) {
          style.transformBox = (styleProp == null ? void 0 : styleProp.transformBox) ?? "fill-box";
          delete attrs.transformBox;
        }
        if (attrX !== void 0)
          attrs.x = attrX;
        if (attrY !== void 0)
          attrs.y = attrY;
        if (attrScale !== void 0)
          attrs.scale = attrScale;
        if (pathLength !== void 0) {
          buildSVGPath(attrs, pathLength, pathSpacing, pathOffset, false);
        }
      }
      const camelCaseAttributes = /* @__PURE__ */ new Set([
        "baseFrequency",
        "diffuseConstant",
        "kernelMatrix",
        "kernelUnitLength",
        "keySplines",
        "keyTimes",
        "limitingConeAngle",
        "markerHeight",
        "markerWidth",
        "numOctaves",
        "targetX",
        "targetY",
        "surfaceScale",
        "specularConstant",
        "specularExponent",
        "stdDeviation",
        "tableValues",
        "viewBox",
        "gradientTransform",
        "pathLength",
        "startOffset",
        "textLength",
        "lengthAdjust"
      ]);
      const isSVGTag = (tag) => typeof tag === "string" && tag.toLowerCase() === "svg";
      function renderSVG(element, renderState, _styleProp, projection) {
        renderHTML(element, renderState, void 0, projection);
        for (const key in renderState.attrs) {
          element.setAttribute(!camelCaseAttributes.has(key) ? camelToDash(key) : key, renderState.attrs[key]);
        }
      }
      function scrapeMotionValuesFromProps(props, prevProps, visualElement) {
        const newValues = scrapeMotionValuesFromProps$1(props, prevProps, visualElement);
        for (const key in props) {
          if (isMotionValue(props[key]) || isMotionValue(prevProps[key])) {
            const targetKey = transformPropOrder.indexOf(key) !== -1 ? "attr" + key.charAt(0).toUpperCase() + key.substring(1) : key;
            newValues[targetKey] = props[key];
          }
        }
        return newValues;
      }
      class SVGVisualElement extends DOMVisualElement {
        constructor() {
          super(...arguments);
          this.type = "svg";
          this.isSVGTag = false;
          this.measureInstanceViewportBox = createBox;
        }
        getBaseTargetFromProps(props, key) {
          return props[key];
        }
        readValueFromInstance(instance, key) {
          if (transformProps.has(key)) {
            const defaultType = getDefaultValueType(key);
            return defaultType ? defaultType.default || 0 : 0;
          }
          key = !camelCaseAttributes.has(key) ? camelToDash(key) : key;
          return instance.getAttribute(key);
        }
        scrapeMotionValuesFromProps(props, prevProps, visualElement) {
          return scrapeMotionValuesFromProps(props, prevProps, visualElement);
        }
        build(renderState, latestValues, props) {
          buildSVGAttrs(renderState, latestValues, this.isSVGTag, props.transformTemplate, props.style);
        }
        renderInstance(instance, renderState, styleProp, projection) {
          renderSVG(instance, renderState, styleProp, projection);
        }
        mount(instance) {
          this.isSVGTag = isSVGTag(instance.tagName);
          super.mount(instance);
        }
      }
      function createDOMVisualElement(element) {
        const options = {
          presenceContext: null,
          props: {},
          visualState: {
            renderState: {
              transform: {},
              transformOrigin: {},
              style: {},
              vars: {},
              attrs: {}
            },
            latestValues: {}
          }
        };
        const node = isSVGElement(element) && !isSVGSVGElement(element) ? new SVGVisualElement(options) : new HTMLVisualElement(options);
        node.mount(element);
        visualElementStore.set(element, node);
      }
      function createObjectVisualElement(subject) {
        const options = {
          presenceContext: null,
          props: {},
          visualState: {
            renderState: {
              output: {}
            },
            latestValues: {}
          }
        };
        const node = new ObjectVisualElement(options);
        node.mount(subject);
        visualElementStore.set(subject, node);
      }
      function animateSingleValue(value, keyframes2, options) {
        const motionValue$1 = isMotionValue(value) ? value : motionValue(value);
        motionValue$1.start(animateMotionValue("", motionValue$1, keyframes2, options));
        return motionValue$1.animation;
      }
      function isSingleValue(subject, keyframes2) {
        return isMotionValue(subject) || typeof subject === "number" || typeof subject === "string" && !isDOMKeyframes(keyframes2);
      }
      function animateSubject(subject, keyframes2, options, scope) {
        const animations = [];
        if (isSingleValue(subject, keyframes2)) {
          animations.push(animateSingleValue(subject, isDOMKeyframes(keyframes2) ? keyframes2.default || keyframes2 : keyframes2, options ? options.default || options : options));
        } else {
          const subjects = resolveSubjects(subject, keyframes2, scope);
          const numSubjects = subjects.length;
          for (let i = 0; i < numSubjects; i++) {
            const thisSubject = subjects[i];
            const createVisualElement = thisSubject instanceof Element ? createDOMVisualElement : createObjectVisualElement;
            if (!visualElementStore.has(thisSubject)) {
              createVisualElement(thisSubject);
            }
            const visualElement = visualElementStore.get(thisSubject);
            const transition = { ...options };
            if ("delay" in transition && typeof transition.delay === "function") {
              transition.delay = transition.delay(i, numSubjects);
            }
            animations.push(...animateTarget(visualElement, { ...keyframes2, transition }, {}));
          }
        }
        return animations;
      }
      function animateSequence(sequence, options, scope) {
        const animations = [];
        const animationDefinitions = createAnimationsFromSequence(sequence, options, scope, { spring });
        animationDefinitions.forEach(({ keyframes: keyframes2, transition }, subject) => {
          animations.push(...animateSubject(subject, keyframes2, transition));
        });
        return animations;
      }
      function isSequence(value) {
        return Array.isArray(value) && value.some(Array.isArray);
      }
      function createScopedAnimate(scope) {
        function scopedAnimate(subjectOrSequence, optionsOrKeyframes, options) {
          let animations = [];
          if (isSequence(subjectOrSequence)) {
            animations = animateSequence(subjectOrSequence, optionsOrKeyframes, scope);
          } else {
            animations = animateSubject(subjectOrSequence, optionsOrKeyframes, options, scope);
          }
          const animation = new GroupAnimationWithThen(animations);
          if (scope) {
            scope.animations.push(animation);
            animation.finished.then(() => {
              removeItem(scope.animations, animation);
            });
          }
          return animation;
        }
        return scopedAnimate;
      }
      const animate = exports("a", createScopedAnimate());
      function invoke(params) {
        const payload = params.payload;
        const selector = payload.selector;
        const el = document.querySelector(selector);
        const items = Array.from(el.querySelectorAll(".parallax-banner__bg-layer"));
        const animationOptions = {
          duration: 1,
          autoplay: false,
          ease: "easeInOut"
        };
        const animationsX = items.map((item) => {
          const offsetX = ~~(item.dataset.offsetX || 10);
          const animation = animate(item, {
            "--offset-x": [`${-offsetX}px`, `${offsetX}px`]
          }, animationOptions);
          animation.time = 0.5;
          return animation;
        });
        const animationsY = items.map((item) => {
          const offsetY = ~~(item.dataset.offsetY || 10);
          const animation = animate(item, {
            "--offset-y": [`${-offsetY}px`, `${offsetY}px`]
          }, animationOptions);
          animation.time = 0.5;
          return animation;
        });
        if (isMobile()) return;
        if (el) {
          let tID = 0;
          const rect = el.getBoundingClientRect();
          const cx = rect.width / 2;
          const cy = rect.height / 2;
          el.addEventListener("mousemove", (evt) => {
            cancelAnimationFrame(tID);
            tID = window.requestAnimationFrame(() => {
              const x = evt.clientX - rect.left;
              const y = evt.clientY - rect.top;
              const dx = x - cx;
              const dy = y - cy;
              const px2 = dx / cx * 0.5 + 0.5;
              const py = dy / cy * 0.5 + 0.5;
              animationsX.forEach((a) => a.time = px2);
              animationsY.forEach((a) => a.time = py);
            });
          });
          el.addEventListener("mouseleave", () => {
            animationsX.forEach((a) => a.time = 0.5);
            animationsY.forEach((a) => a.time = 0.5);
          });
        }
      }
      const parallaxBanner = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
        __proto__: null,
        default: invoke
      }, Symbol.toStringTag, { value: "Module" }));
      exports("ay", parallaxBanner);
    }
  };
});
